import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject, EMPTY, forkJoin, Subject } from 'rxjs';
import { ProjConstants } from 'src/app/utils/proj.constant';
import * as L from 'leaflet';
import * as R from 'leaflet-responsive-popup'
import "src/assets/js/maplibs/L.uGeoJson.js";
import 'src/assets/js/maplibs/L.TileLayer.ColorFilter.js'
import 'src/assets/js/maplibs/L.TileLayer.ColorFIlter.min.js'
import 'src/assets/js/maplibs/L.vectorgrid.bundle.js';
import 'src/assets/js/maplibs/Leaflet-WMS.js';
import 'src/assets/js/maplibs/leaflet.responsive.popup.js'
import { isNullOrUndefined } from 'util';
import { environment } from 'src/environments/environment';
import { MapConstants } from 'src/app/utils/map.constant';
import { AlertMapConstants, gisIPKwaramGeo, gisStoreName, gisVassarlabsStoreName, LAYER_LIST, LAYER_TYPES, LOCATION_UUID, LOCATIONS_ZOOM, LOCATIONS_ZOOM_RANGE, MITANK_MANDAL_CLUSTER, MITANK_POLYGON_LAYER, VisibilityMapConstants } from './alert-gis/alert-gis.const';
import { AlertDataService } from './alert-data.service';
import * as moment from 'moment';
import { catchError } from 'rxjs/operators';
import { GeoJSONObject } from '@turf/turf';
import { LabelType } from '@angular-slider/ngx-slider';
import { Router } from '@angular/router';
import { isEmptyObject } from 'jquery';


@Injectable({
  providedIn: 'root'
})
export class AlertMapService {
  activeFeatureData: Object = {
    "id": null,
    "uuid": null,
    "layer": null,
    "external_i": null
  };
  colorStyling={
    map1:{
      'Categorization of Assessment unit':{},
      'Annual Ground Water Extraction':{},
      'Annual Ground Water Recharge':{},
      'Annual Normal Rainfall':{}
    },
    map2:{
      'Categorization of Assessment unit':{},
      'Annual Ground Water Extraction':{},
      'Annual Ground Water Recharge':{},
      'Annual Normal Rainfall':{}
    }
  }
  versionDetails={
    map1:[],
    map2:[]
  }
  params: any;
  heatMapParams: any;
  urlConstants = environment.url;
  injectedService;
  private updateSourceNameSource = new Subject<any>();
  public updateSourceName$ = this.updateSourceNameSource.asObservable();
  visibilityMiTanksSource = "SENTINEL_1";
  rfAggrData : any ;
  rfMiniFlag : boolean = true;
  riverGeoData : any ;
  pointGeoData : any ;
  inflowRiver : any = false;
  inflowPoint : any = true;

  isOpenDataTab = new BehaviorSubject(false);
  apiUrl: any;
  highlightStationsArrGlobal: any;
  riverNetworkLayerStyling: any = {};
  classBasedOnFloodConditionOfPointType: any;
  metaData: any;
  catchmentLayerList: any = [];
  maxCapacity = 313;
  minCapacity = 0.4;
  minRadius = 3;
  maxRadius = 30;
  rivergaugeData: any;
  reservoirData : any;
  labelStrings: any;
  forecastTimeLayers: {};
  checkforIMDheatmap: any;
  alertsColorData: any;
  majorReservoirs : any = ["1c20cc80-9c3f-4a6f-bc74-e16b29b5ad9a","9e2cb9f8-743b-473a-b966-7d11cb000a79","04affbff-36d4-458a-9c32-baa64eb6eab0","78ae1628-336d-11e9-b210-d663bd873d93",
    "52f0e841-9f3f-4f08-9e2e-80782055ddcf","f03b0998-3644-4e67-9a16-e7258c136475","1a837a05-e220-4554-a444-d62a31f40dcc","129ef2e7-05f7-409f-bfca-2dda47669060","78ae40b2-336d-11e9-b210-d663bd873d93",
    "0e6be4a2-db2a-42c0-a01d-9de81d835a5e","cdad2a5e-91ab-11e5-8994-feff819cdc9f","13c7d756-b5a5-4938-bc90-f380c1bdf324","0f512470-1770-11e6-b6ba-3e1d05defe78",
"78ae2974-336d-11e9-b210-d663bd873d93","7e103cea-040e-464a-9dbe-d7a17bda3fc2","cb4a8d34-5463-40af-8bea-976b10d1705a","cdad2e1e-91ab-11e5-8994-feff819cdc9f","b1651343-8580-4b6d-ac5d-d6b4688260ec",
"2047859b-a4c5-4f4b-a9e6-35d06bdf0fab","78ae4724-336d-11e9-b210-d663bd873d93","3a4daec9-661f-4400-9a21-cad79c1f758a","78ae56f6-336d-11e9-b210-d663bd873d93", 
"d61f5d35-82fe-4361-a05a-b067cba27fe5"
  ]
  miTanksData: any;
  miTanksMandalData: any;

  constructor(private http: HttpClient,
    private utilsSrv: AlertDataService,
    private dataService: AlertDataService,
    private injector: Injector,
    private gisUtils: AlertDataService,
    private router: Router,
  ) {
    this.apiUrl = ProjConstants.API_URL;
    this.gisUtils.getSelectedParams().subscribe(res => {
      if (!this.utilsSrv.isEmptyObj(res)) {
        this.params = res;
      }
    })
    // this.gisUtils.getGwmsData().subscribe(res =>{
    //   if (!this.utilsSrv.isEmptyObj(res)) {
    //     this.params = res;
    //   }
    // })
    this.gisUtils.getSelectedHeatMap().subscribe(res => {
      if (!this.utilsSrv.isEmptyObj(res)) {
        this.heatMapParams = res;
      }
    });
    this.gisUtils.getNavigatedLayer().subscribe(res => {
      if (!this.utilsSrv.isEmptyObj(res)) {
        this.navigationFromLayers(res);
      }
    })
  }

  addTileLayer(layerOptions) {
    let tileLayer;
    if (layerOptions.name === 'Google Satellite') {
      tileLayer = (L.tileLayer as any).colorFilter(
        layerOptions.url,
        layerOptions
      );
    }
    else
      tileLayer = new L.TileLayer(layerOptions.url, layerOptions);
    return tileLayer;
  }

  addBaseTileLayers(layerList, mapObj) {
    let baselayers = {}
    for (let index in layerList) {
      let layer = layerList[index];
      let layerObj
      layerObj = this.addTileLayer(layer);
      if (layer['visible']) {
        mapObj.removeLayer(layerObj);
        mapObj.addLayer(layerObj);
      } else {
        mapObj.removeLayer(layerObj);
      }
      baselayers[layer['name']] = layerObj;
    }
    return baselayers;
  }

  getApplicationBasedLayer(layerList, layerType, params?) {
    if (layerType == LAYER_TYPES.WMS_LAYER)
      return this.getWMSOverLays(layerList, params);
    else if (layerType == LAYER_TYPES.VECTOR_LAYER)
      return this.getVECTOROverlays(layerList, params);
    else if (layerType == LAYER_TYPES.GEOJSON_LAYER)
      return this.getGEOJSONOverLays(layerList);
    else if (layerType == LAYER_TYPES.HEATMAP_LAYER)
      return this.getHeatMapOverlays(layerList, {});
    else if (layerType == LAYER_TYPES.CLUSTER_LAYER)
      return this.getCLUSTEROverLays(layerList);
  }

  getWMSOverLays(data, params?) {
    let overlays = {};
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const value = data[key];
        let overlay: any = {};
        overlay.name = value.name;
        overlay.type = 'wms';
        overlay.component = value.component;
        overlay.layerOptions = {};
        if (value.cType && value.cType.length > 0) {
          overlay.layerOptions.cType = value.cType;
        }
        if (params && params['pUUID']) {
          overlay.layerOptions.pUUID = params['pUUID'];
        }
        overlay.layerOptions.name = value.name;
        overlay.layerOptions.format = 'image/png';
        overlay.layerOptions.transparent = true;
        if (overlay.name === 'State Names')
          overlay.url = this.urlConstants.NEW_GEOSERVER_URL + 'HEATWAVE/ows';
        else if (overlay.name && overlay.name.includes('Sentinel') && !overlay.name.includes('Depth')) {
          overlay.url = value.url;
        } else if (overlay.name.includes('Depth')) {
          overlay.url = this.getAzureGeoserverURL() + "/wms";
        }
        // else if(overlay.layerOptions.name == "STATE MASK"){
        //   overlay.url = "https://ingres.iith.ac.in/geoserver/gec/"+"/wms";
        // }
        else overlay.url = this.getGeoServerURL() + "/wms";
        if (this.validateValue(value.hasLegend))
          overlay.layerOptions.hasLegend = value.hasLegend;
        if (this.validateValue(value.legendName))
          overlay.layerOptions.legendName = value.legendName;
        if (this.validateValue(value.key))
          overlay.layerOptions.key = value.key;
        if (this.validateValue(value.view))
          overlay.layerOptions.view = value.view;
        if (this.validateValue(value.displayName))
          overlay.layerOptions.displayName = value.displayName;
        if (this.validateValue(value.imagesrc))
          overlay.layerOptions.imagesrc = value.imagesrc;
        if (this.validateValue(value.source))
          overlay.layerOptions.source = value.source;
        if (this.validateValue(value.layer_name))
          overlay.layerOptions.layer_name = value.layer_name;
        if (this.validateValue(value.cql_filter))
          overlay.layerOptions.cql_filter = value.cql_filter;
        if (this.validateValue(value.cql_filter_value)) {
          overlay.layerOptions.cql_filter_value = value.cql_filter_value;
        }
        if (this.validateValue(value.subgroup))
          overlay.layerOptions.subgroup = value.subgroup;
        if (this.validateValue(value.visible))
          overlay.layerOptions.visible = value.visible;
        if (this.validateValue(value.dashboardView))
          overlay.layerOptions.dashboardView = value.dashboardView;
        if (this.validateValue(value.group))
          overlay.layerOptions.group = value.group;
        if (this.validateValue(value.layeroptions_name))
          overlay.layerOptions.layers = value.layeroptions_name;
        if (this.validateValue(value.layeroptions_min_zoom))
          overlay.layerOptions.minZoom = value.layeroptions_min_zoom;
        if (this.validateValue(value.layeroptions_max_zoom))
          overlay.layerOptions.maxZoom = value.layeroptions_max_zoom;
        if (this.validateValue(value.layeroptions_pane)) {
          overlay.layerOptions.pane = value.layeroptions_pane;
        }
        if (this.validateValue(value.layeroptions_zindex)) {
          overlay.layerOptions.zIndex = value.layeroptions_zindex;
        }
        if (this.validateValue(value.layeroptions_show_on_selector) && !value.layeroptions_show_on_selector)
          overlay.layerOptions.showOnSelector = value.layeroptions_show_on_selector;
        if (this.validateValue(value.group_type)) {
          overlay.layerOptions.groupType = value.group_type
        }
        if (this.validateValue(value.data)) {
          overlay.layerOptions.data = value.data
        }
        if (this.validateValue(value.crs) && value.crs == "EPSG4326") {
          overlay.layerOptions.crs = L.CRS.EPSG4326;
        }
        if (this.validateValue(value.position)) {
          overlay.layerOptions.position = value.position;
        }
        // if (overlay.layerOptions.layers &&overlay.layerOptions.layers.includes('gec'))
        //   {
        //     overlay.url = this.getIngresURL() + "/wms";
        //   }
        if (value.type === 'WMS') {

          if (overlay.name === 'Sentinel 1' || overlay.name === 'Sentinel 2 FCC' || overlay.name === 'Sentinel 2 TCC' ||
            overlay.name.includes('ALOS') || overlay.name ==='Irrigation Base Layer') {
            overlay.key = overlay.name;
            overlays[overlay.name] = overlay;
          }
          else {
            overlay.key = key;
            overlay.layerOptions.key = key;
            overlays[key] = overlay;
          }
        }
        if (this.validateValue(value.layeroptions_styles)) {
          overlay.layerOptions.STYLES = value.layeroptions_styles;
        }
        if (this.validateValue(value.info)) {
          overlay.layerOptions.info = value.info
        }
      }
    }
    return overlays;
  }

  getGeoServerURL(geo?) {
    let url = this.urlConstants.NEW_GEOSERVER_URL + 'HEATWAVE';
    
    return url;
  }
  getAzureGeoserverURL() {
    let url = this.urlConstants.NEW_GEOSERVER_URL + 'HEATWAVE';
    return url;
  }

  validateValue(value) {
    if (isNullOrUndefined(value)) return false;
    return true;
  }

  setWMSOverlays(mapObject, wmsLayers, layersList?) {
    let layers = {};
    for (const key in wmsLayers) {
      if (wmsLayers.hasOwnProperty(key)) {
        const layer: any = wmsLayers[key];
        if (!layer.layerOptions.cql_filter)
          layer.layerOptions.cql_filter = '1=1';
        let wmslayer
        if (key == 'SRTM_DEM_30') {
          wmslayer = new L.TileLayer.WMS(layer.url,
            {
              layers: layer.layerOptions.layers,
              format: "image/png",
              transparent: true,
              attribution: layer.layerOptions.attribution || "",
              minZoom: layer.layerOptions.minZoom,
              maxZoom: layer.layerOptions.maxZoom,
              pane: layer.layerOptions.pane,
              styles: layer.layerOptions.STYLES,
            }
          );
        }
        else {
          wmslayer = new L.TileLayer.WMS(layer.url,
            layer.layerOptions)
        }
        layers[key] = wmslayer;
        if (layersList) {
          if (mapObject.hasLayer(layersList[key])) {
            mapObject.removeLayer(layersList[key])
          }
        }
        if (!key.startsWith('Depth_Class'))
          if (layer.layerOptions.visible === true) {
            mapObject.addLayer(layers[key])
          }
      }
    }
    return layers;
  }

  getCircleMarkerRadius(zoomLevel: number, currentRadius) {
    return currentRadius * zoomLevel * 0.25;
  }

  getGEOJSONOverLays(data) {
    let overlays = {};
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const value = data[key];
        let overlay: any = {};
        overlay.name = value.name;
        overlay.type = 'GEOJSON';
        overlay.layerOptions = {};
        if (value.cType && value.cType.length > 0) {
          overlay.cType = value.cType;
          overlay.layerOptions.cType = value.cType;
        }
        overlay.layerOptions.type = 'GEOJSON';
        overlay.layerOptions.name = value.name;
        overlay.layerOptions.format = 'image/png';
        overlay.layerOptions.transparent = true;
        if (this.validateValue(value.hasLegend))
          overlay.layerOptions.hasLegend = value.hasLegend;
        if (this.validateValue(value.legendName))
          overlay.layerOptions.legendName = value.legendName;
        if (this.validateValue(value.legendData))
          overlay.layerOptions.legendData = value.legendData;
        if (this.validateValue(value.component))
          overlay.layerOptions.component = value.component;
        if (this.validateValue(value.view))
          overlay.layerOptions.view = value.view;
        if (this.validateValue(value.layer_name))
          overlay.layerOptions.layer_name = value.layer_name;
        if (this.validateValue(value.cqlfilter))
          overlay.layerOptions.cql_filter = value.cqlfilter;
        if (this.validateValue(value.cql_filter_value))
          overlay.layerOptions.cql_filter_value = value.cql_filter_value;
        if (this.validateValue(value.source))
          overlay.layerOptions.source = value.source;
        if (this.validateValue(value.visible))
          overlay.layerOptions.visible = value.visible;
        if (this.validateValue(value.layerFrom))
          overlay.layerOptions.layerFrom = value.layerFrom;
        if (this.validateValue(value.includeAll))
          overlay.layerOptions.includeAll = value.includeAll;
        if (this.validateValue(value.displayName))
          overlay.layerOptions.displayName = value.displayName;
        if (this.validateValue(value.style))
          overlay.layerOptions.style = value.style;
        if (this.validateValue(value.onEachFeature))
          overlay.layerOptions.onEachFeature = value.onEachFeature;
        if (this.validateValue(value.pointToLayer))
          overlay.layerOptions.pointToLayer = value.pointToLayer;
        if (this.validateValue(value.layerType))
          overlay.layerOptions.layerType = value.layerType;
        if (this.validateValue(value.afterLayerAddition))
          overlay.layerOptions.afterLayerAddition = value.afterLayerAddition;
        if (this.validateValue(value.group))
          overlay.layerOptions.group = value.group;
        if (this.validateValue(value.canalWMSLayer))
          overlay.layerOptions.canalWMSLayer = value.canalWMSLayer;
        if (this.validateValue(value.layeroptions_name))
          overlay.layerOptions.layers = value.layeroptions_name;
        if (this.validateValue(value.layeroptions_min_zoom))
          overlay.layerOptions.minZoom = value.layeroptions_min_zoom;
        if (this.validateValue(value.layeroptions_max_zoom))
          overlay.layerOptions.maxZoom = value.layeroptions_max_zoom;
        if (this.validateValue(value.layeroptions_pane)) {
          overlay.layerOptions.pane = value.layeroptions_pane;
        }
        if (this.validateValue(value.layeroptions_zindex)) {
          overlay.layerOptions.zIndex = value.layeroptions_zindex;
        }
        if (this.validateValue(value.layeroptions_show_on_selector) && !value.layeroptions_show_on_selector)
          overlay.layerOptions.showOnSelector = value.layeroptions_show_on_selector;
        if (this.validateValue(value.group_type)) {
          overlay.layerOptions.groupType = value.group_type
        }
        if (this.validateValue(value.data)) {
          overlay.layerOptions.data = value.data
        }
        if (this.validateValue(value.crs) && value.crs == "EPSG4326") {
          overlay.layerOptions.crs = L.CRS.EPSG4326;
        }
        if (this.validateValue(value.position)) {
          overlay.layerOptions.position = value.position;
        }
        if (value.type === 'GEOJSON') {
          overlay.key = key;
          overlays[key] = overlay;
        }
        if (this.validateValue(value.layeroptions_styles)) {
          overlay.layerOptions.STYLES = value.layeroptions_styles;
        }
        if (this.validateValue(value.info)) {
          overlay.layerOptions.info = value.info
        }
      }
    }
    return overlays;
  }

  getCLUSTEROverLays(data) {
    let overlays = {};
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const value = data[key];
        if(value.hasOwnProperty("type") && value.type == 'CLUSTER'){
          let overlay: any = {};
          overlay.name = value.name;
          overlay.type = 'CLUSTER';
          overlay.layerOptions = {};
          if (value.cType && value.cType.length > 0) {
            overlay.cType = value.cType;
            overlay.layerOptions.cType = value.cType;
          }
          overlay.layerOptions.type = "CLUSTER";
          overlay.layerOptions.name = value.name;
          if (this.validateValue(value.hasLegend))
            overlay.layerOptions.hasLegend = value.hasLegend;
          if (this.validateValue(value.legendName))
            overlay.layerOptions.legendName = value.legendName;
          if (this.validateValue(value.legendData))
            overlay.layerOptions.legendData = value.legendData;
          if (this.validateValue(value.component))
            overlay.layerOptions.component = value.component;
          if (this.validateValue(value.view))
            overlay.layerOptions.view = value.view;
          if (this.validateValue(value.layer_name))
            overlay.layerOptions.layer_name = value.layer_name;
          if (this.validateValue(value.cqlfilter))
            overlay.layerOptions.cql_filter = value.cqlfilter;
          if (this.validateValue(value.cql_filter_value))
            overlay.layerOptions.cql_filter_value = value.cql_filter_value;
          if (this.validateValue(value.source))
            overlay.layerOptions.source = value.source;
          if (this.validateValue(value.visible))
            overlay.layerOptions.visible = value.visible;
          if (this.validateValue(value.layerFrom))
            overlay.layerOptions.layerFrom = value.layerFrom;
          if (this.validateValue(value.includeAll))
            overlay.layerOptions.includeAll = value.includeAll;
          if (this.validateValue(value.displayName))
            overlay.layerOptions.displayName = value.displayName;
            if (this.validateValue(value.key))
            overlay.layerOptions.key = value.key;

          if (this.validateValue(value.style))
            overlay.layerOptions.style = value.style;
          if (this.validateValue(value.onEachFeature))
            overlay.layerOptions.onEachFeature = value.onEachFeature;
          if (this.validateValue(value.pointToLayer))
            overlay.layerOptions.pointToLayer = value.pointToLayer;
          if (this.validateValue(value.afterLayerAddition))
            overlay.layerOptions.afterLayerAddition = value.afterLayerAddition;

          if (this.validateValue(value.group))
            overlay.layerOptions.group = value.group;
          if (this.validateValue(value.layeroptions_name))
            overlay.layerOptions.layers = value.layeroptions_name;
          if (this.validateValue(value.layeroptions_min_zoom))
            overlay.layerOptions.minZoom = value.layeroptions_min_zoom;
          if (this.validateValue(value.layeroptions_max_zoom))
            overlay.layerOptions.maxZoom = value.layeroptions_max_zoom;
          if (this.validateValue(value.layeroptions_pane)) {
            overlay.layerOptions.clusterPane = value.layeroptions_pane;
          }
          if (this.validateValue(value.layeroptions_zindex)) {
            overlay.layerOptions.zIndex = value.layeroptions_zindex;
          }
          if (this.validateValue(value.layeroptions_show_on_selector) && !value.layeroptions_show_on_selector)
            overlay.layerOptions.showOnSelector = value.layeroptions_show_on_selector;
          if (this.validateValue(value.groupType)) {
            overlay.layerOptions.groupType = value.groupType
          }
          if (this.validateValue(value.group_type)) {
            overlay.layerOptions.groupType = value.group_type
          }
          if (this.validateValue(value.data)) {
            overlay.layerOptions.data = value.data
          }
          if (this.validateValue(value.crs) && value.crs == "EPSG4326") {
            overlay.layerOptions.crs = L.CRS.EPSG4326;
          }
          if (this.validateValue(value.position)) {
            overlay.layerOptions.position = value.position;
          }
          if (this.validateValue(value.chunkedLoading)) {
            overlay.layerOptions.chunkedLoading = value.chunkedLoading;
          }
          if (this.validateValue(value.disableClusteringAtZoom)) {
            overlay.layerOptions.disableClusteringAtZoom = value.disableClusteringAtZoom;
          }
          if (this.validateValue(value.spiderfyOnMaxZoom)) {
            overlay.layerOptions.spiderfyOnMaxZoom = value.spiderfyOnMaxZoom;
          }
          if (this.validateValue(value.clusterFunctionName)) {
            overlay.layerOptions.clusterFunctionName = value.clusterFunctionName;
          }
          if (this.validateValue(value.showCoverageOnHover)) {
            overlay.layerOptions.showCoverageOnHover = value.showCoverageOnHover;
          }
          if (this.validateValue(value.zoomToBoundsOnClick)) {
            overlay.layerOptions.zoomToBoundsOnClick = value.zoomToBoundsOnClick;
          }
          if (this.validateValue(value.maxClusterRadius)) {
            overlay.layerOptions.maxClusterRadius = value.maxClusterRadius;
          }
          if (this.validateValue(value.polygonOptions)) {
            overlay.layerOptions.polygonOptions = value.polygonOptions;
          }
          if (this.validateValue(value.singleMarkerMode)) {
            overlay.layerOptions.singleMarkerMode = value.singleMarkerMode;
          }
          if (this.validateValue(value.iconCreateFunction)) {
            overlay.layerOptions.iconCreateFunction = value.iconCreateFunction;
          }
          if (this.validateValue(value.emitFromLayerControl)) {
            overlay.layerOptions.emitFromLayerControl = value.emitFromLayerControl;
          } 
          if (this.validateValue(value.maxClusterRadius)) {
            overlay.layerOptions.maxClusterRadius = value.maxClusterRadius;
          }   
              

          if (value.type === 'CLUSTER') {
            overlay.key = key;
            overlays[key] = overlay;
          }
          if (this.validateValue(value.layeroptions_styles)) {
            overlay.layerOptions.STYLES = value.layeroptions_styles;
          }
          if (this.validateValue(value.info)) {
            overlay.layerOptions.info = value.info
          }
        }
      }
    }
    return overlays;
  }

  getHeatMapOverlays(layersList, imageData) {
    var overlays = {};
    for (const key in layersList) {
      if (layersList.hasOwnProperty(key)) {
        const value = layersList[key];
        let overlay: any = {};
        overlay.name = value.name;
        overlay.type = 'image';
        overlay.layerOptions = {};
        overlay.layerOptions.name = value.name;
        if (this.validateValue(imageData[overlay.name]))
          // overlay.bounds = this.getBlockBoundsForType(basinName)
          if (this.validateValue(value.group_type)) {
            overlay.layerOptions.groupType = value.group_type
          }
        if (this.validateValue(value.component))
          overlay.layerOptions.component = value.component;
        if (this.validateValue(value.hasLegend))
          overlay.layerOptions.hasLegend = value.hasLegend;
        if (this.validateValue(value.key))
          overlay.layerOptions.key = value.key;
        if (this.validateValue(value.legendName))
          overlay.layerOptions.legendName = value.legendName;
        if (this.validateValue(value.legendData))
          // overlay.layerOptions.legendData = legendData ? legendData : value.legendData;
          if (this.validateValue(value.subgroup))
            overlay.layerOptions.subgroup = value.subgroup;
        if (this.validateValue(value.displayName))
          overlay.layerOptions.displayName = value.displayName;
        if (this.validateValue(value.visible))
          overlay.layerOptions.visible = value.visible;
        if (this.validateValue(value.group))
          overlay.layerOptions.group = value.group;
        if (this.validateValue(value.type))
          overlay.layerOptions.type = value.type;
        if (this.validateValue(value.layeroptions_name))
          overlay.layerOptions.layerName = value.layeroptions_name;
        if (this.validateValue(value.layeroptions_pane)) {
          overlay.layerOptions.pane = value.layeroptions_pane;
        }
        if (this.validateValue(value.layeroptions_min_zoom))
          overlay.layerOptions.minZoom = value.layeroptions_min_zoom;
        if (this.validateValue(value.layeroptions_max_zoom))
          overlay.layerOptions.maxZoom = value.layeroptions_max_zoom;
        if (this.validateValue(value.layeroptions_show_on_selector) && !value.layeroptions_show_on_selector)
          overlay.layerOptions.showOnSelector = value.layeroptions_show_on_selector;
        if (value.type === 'HEATMAP' && !this.validateValue(value.image_path)) {
          if (this.validateValue(imageData[overlay.name])) {
            overlay.url = imageData[overlay.name].url
              overlays[key] = overlay;
          }
          else {
            overlay.url = imageData[value.layeroptions_name];
            overlays[key] = overlay;
          }
        } else if (value.type === 'HEATMAP' && this.validateValue(value.image_path)) {
          overlay.url = value.image_path;
          overlays[key] = overlay;
        }
        if (this.validateValue(value.info)) {
          overlay.layerOptions.info = value.info
        }
      }
    }
    return overlays;
  }

  checkZoomlevelsForGeoJSON(layeroptions, currentZoom) {
    if (layeroptions && layeroptions['maxZoom'] && layeroptions['minZoom'] && layeroptions['maxZoom'] >= currentZoom && layeroptions['minZoom'] <= currentZoom && layeroptions['visible']) return true;
    return false;
  }

  addGeoJsonLayersToMap(geoJsonData: GeoJSONObject, mapObj: L.Map, layerOptions: any, otherOptions, params, gisMapComp) {
    let service,layerType;
    service = this.injector.get(otherOptions['serviceType']);
    layerType =layerOptions.layerType ? layerOptions.layerType : null;
    let geoJsonLayer = L.geoJSON(geoJsonData, {
          style: function (feature) {
            if(layerOptions.style){
             return service[layerOptions.style](feature); 
            }
          },
          pointToLayer: (feature, layer) => {
            if (layerOptions.pointToLayer){
              if(layerType!=null){
                return service[layerOptions.pointToLayer](feature, mapObj, params, gisMapComp,layerOptions.layerType);
              }else{
                return service[layerOptions.pointToLayer](feature, mapObj, params, gisMapComp)
              }
            }
          },
          onEachFeature: function (feature, layer) {
              if (layerOptions.onEachFeature)
                  return service[layerOptions.onEachFeature](layer, mapObj, params, gisMapComp,feature)
          },
          pane: layerOptions.pane
      });
          if (layerOptions.afterLayerAddition && service[layerOptions.afterLayerAddition] && geoJsonData && geoJsonData['features'] && geoJsonData['features'].length > 0) {
      service[layerOptions.afterLayerAddition](gisMapComp);
    }
    return geoJsonLayer;
  }

  getCqlFilter(layerOptions) {
    let filter = null;
    filter = layerOptions.cql_filter || null;
    return filter;
  }

  getGeoJsonLayerData(layerName, filter): Promise<any> {
    let response = {};
    let promise = new Promise((resolve, reject) => {
      this.dataService.getLayerWithFilter(layerName, filter).subscribe(async (geodata: GeoJSONObject) => {
        response = geodata;
        if (geodata) {
          response = geodata;
        }
        resolve(response);
      });
      err => {
        console.log("Error Occurred", err);
        reject(response);
      }
    });
    return promise;
  }

  async setGEOJSONOverlays(mapObject, layerList, layerObjectsList, otherOptions, gisMapComp?): Promise<any> {
        gisMapComp.spinner = true;
    return new Promise(async (resolve, reject) => {
      let geoJsonOverlay = {};
      let filter = null;
      this.inflowPoint = true;
      this.inflowRiver = true;
      this.pointGeoData = {};
      this.riverGeoData = {};
      for (const key in layerList) {
        if (mapObject.hasLayer(layerObjectsList['overlaylayers'][key])) {
          mapObject.removeLayer(layerObjectsList['overlaylayers'][key]);
        }
        let concentricCircleLayer = new L.LayerGroup();
        const val = layerList[key];
        if (val.type === 'GEOJSON' && val.layerOptions.layerFrom == VisibilityMapConstants.SOURCES.BACKEND) {
          // backendLayerCheck = true;
          let srv
          srv = this.injector.get(otherOptions['serviceType']);
          if(gisMapComp.params['component'] == "RAINFALL"){
            concentricCircleLayer = await srv[otherOptions['sensorLayerFunctionName']](gisMapComp, val, mapObject,);
          }else{
            concentricCircleLayer = await srv[otherOptions['sensorLayerFunctionName']](this, val, mapObject);
          }
        }
        else if (val.type === 'GEOJSON' && val.layerOptions.layerFrom == VisibilityMapConstants.SOURCES.GEOSERVER) {
          let layerName = val.layerOptions.layers.includes('HEATWAVE:') ? val.layerOptions.layers.split('HEATWAVE:') : val.layerOptions.layers.split('HEATWAVE:');
          filter = this.getCqlFilter(val.layerOptions);
          if (!isNullOrUndefined(layerName[1])) {
            let geodata : any;
            if(gisMapComp.params&&gisMapComp.params['component']){
              geodata = await this.getGeoJsonLayerData(layerName[1], filter);
            }         
            concentricCircleLayer = await this.addGeoJsonLayersToMap(geodata, mapObject, val.layerOptions, otherOptions, this.params, gisMapComp);
          }
          // }else if(val.type === 'GEOJSON' && val.layerOptions.layerFrom == VisibilityMapConstants.SOURCES.AZURE_GEOSERVER){
        }
        // if (mapObject.hasLayer(layerObjectsList['overlaylayers'][key])) {
        //   mapObject.removeLayer(layerObjectsList['overlaylayers'][key]);
        // }
        // if(!isNullOrUndefined(concentricCircleLayer)){
        concentricCircleLayer['options'] = { ...val, ...concentricCircleLayer['options'] };
        geoJsonOverlay[key] = concentricCircleLayer;
        geoJsonOverlay[key].options = { ...geoJsonOverlay[key].options, ...concentricCircleLayer['options']['layerOptions'] };
        // }
        if (gisMapComp.activeLayers[key]) {
          geoJsonOverlay[key].options.visible = gisMapComp.activeLayers[key];
        }
        // console.log("\n this.checkZoomlevelsForGeoJSON(layerList[key].layerOptions,mapObject.getZoom()) \n",key,concentricCircleLayer,geoJsonOverlay[key].options);

        // Code for Crop Demand
        if (!isNullOrUndefined(mapObject) && !isNullOrUndefined(geoJsonOverlay[key]) &&
          this.checkZoomlevelsForGeoJSON(geoJsonOverlay[key].options, mapObject.getZoom()) && geoJsonOverlay[key].options.visible) {
          mapObject.addLayer(geoJsonOverlay[key]);
          gisMapComp.activeLayers[key] = true;
        }
      }
      gisMapComp.spinner = false;
      resolve(geoJsonOverlay);
    });
  }

  async setCLUSTEROverlays(mapObject, layerList, layerObjectsList, otherOptions, gisMapComp?): Promise<any> {
    gisMapComp.spinner = true;
    return new Promise(async (resolve, reject) => {
      let clusterOverlay = {};
      let filter = null;
      for (const key in layerList) {
        if (mapObject.hasLayer(layerObjectsList['overlaylayers'][key])) {
          mapObject.removeLayer(layerObjectsList['overlaylayers'][key]);
        }
        let clusterLayer;
        const val = layerList[key];

        if (val.type === 'CLUSTER' && val.layerOptions.layerFrom == VisibilityMapConstants.SOURCES.BACKEND) {
          // backendLayerCheck = true;
          let srv
            srv = this.injector.get(otherOptions['serviceType']);
            clusterLayer = await srv[val.layerOptions.clusterFunctionName](gisMapComp, val, mapObject);
        
        }
        else if (val.type === 'CLUSTER' && val.layerOptions.layerFrom == VisibilityMapConstants.SOURCES.GEOSERVER) {
          // let layerName = val.layerOptions.layers.includes('tamilnadu:') ? val.layerOptions.layers.split('tamilnadu:') : val.layerOptions.layers.split('tamilnadu:');
          // filter = this.getFilterForMITanks(val.layerOptions);
          // if (!isNullOrUndefined(layerName[1])) {
          //   let geodata = await this.getGeoJsonLayerData(layerName[1], filter);
          //   concentricCircleLayer = await this.addGeoJsonLayersToMap(geodata, mapObject, val.layerOptions, otherOptions, this.params, gisMapComp);
          // }
          // }else if(val.type === 'GEOJSON' && val.layerOptions.layerFrom == VisibilityMapConstants.SOURCES.AZURE_GEOSERVER){
        }
        // if (mapObject.hasLayer(layerObjectsList['overlaylayers'][key])) {
        //   mapObject.removeLayer(layerObjectsList['overlaylayers'][key]);
        // }
        // if(!isNullOrUndefined(concentricCircleLayer)){

        // clusterLayer['options'] = { ...val, ...clusterLayer['options'] };
        clusterOverlay[key] = clusterLayer;
        // clusterOverlay[key].options = { ...clusterOverlay[key].options, ...clusterLayer['options']['layerOptions'] };
        // }

        // if (gisMapComp.activeLayers[key]) {
        //   clusterOverlay[key].options.visible = gisMapComp.activeLayers[key];
        // }

        if (!isNullOrUndefined(mapObject) && !isNullOrUndefined(clusterOverlay[key]) && clusterOverlay[key].options.visible) {
          mapObject.addLayer(clusterOverlay[key]);
          gisMapComp.activeLayers[key] = true;
        }
      }
      gisMapComp.spinner = false;
      resolve(clusterOverlay);
    });
  }

  // async setGEOJSONOverlays(mapObject, layerList, layerObjectsList, otherOptions,gisMapComp?) : Promise<any>  {
  //   gisMapComp.spinner = true;
  //   return new Promise(async (resolve, reject) => {
  //     let geoJsonOverlay = {};
  //     let filter = null;
  //     for (const key in layerList) {
  //       if (mapObject.hasLayer(layerObjectsList['overlaylayers'][key])) {
  //         mapObject.removeLayer(layerObjectsList['overlaylayers'][key]);
  //       }
  //       let concentricCircleLayer = new L.LayerGroup();
  //       const val = layerList[key];

  //       if (val.type === 'GEOJSON' && val.layerOptions.layerFrom == this.gisMapConst.SOURCES.BACKEND) {
  //         // backendLayerCheck = true;
  //         let srv = this.injector.get(otherOptions['serviceType']);
  //         concentricCircleLayer = await srv[otherOptions['sensorLayerFunctionName']](this, val, mapObject);
  //       }
  //       else if (val.type === 'GEOJSON' && val.layerOptions.layerFrom == this.gisMapConst.SOURCES.GEOSERVER) {
  //         let layerName = val.layerOptions.layers.split('kaleshwaram:');
  //           filter = this.getFilterForMITanks(val.layerOptions);
  //           if (!isNullOrUndefined(layerName[1])) {
  //             let geodata =  await this.getGeoJsonLayerData(layerName[1],filter);
  //               concentricCircleLayer = await this.addGeoJsonLayersToMap(geodata, mapObject, val.layerOptions, otherOptions, this.params,gisMapComp);
  //           }
  //           }
  //           // if (mapObject.hasLayer(layerObjectsList['overlaylayers'][key])) {
  //           //   mapObject.removeLayer(layerObjectsList['overlaylayers'][key]);
  //           // }
  //           // if(!isNullOrUndefined(concentricCircleLayer)){
  //             concentricCircleLayer['options'] = {...val,...concentricCircleLayer['options']};
  //           geoJsonOverlay[key] = concentricCircleLayer;
  //           geoJsonOverlay[key].options = {...geoJsonOverlay[key].options,...concentricCircleLayer['options']['layerOptions']};
  //           // }
  //             if(gisMapComp.activeLayers[key]){
  //             geoJsonOverlay[key].options.visible = gisMapComp.activeLayers[key];
  //           }
  //           // console.log("\n this.checkZoomlevelsForGeoJSON(layerList[key].layerOptions,mapObject.getZoom()) \n",key,concentricCircleLayer,geoJsonOverlay[key].options);
  //           if (!isNullOrUndefined(mapObject) && !isNullOrUndefined(geoJsonOverlay[key]) &&
  //           this.checkZoomlevelsForGeoJSON( geoJsonOverlay[key].options, mapObject.getZoom()) && geoJsonOverlay[key].options.visible) {
  //             mapObject.addLayer(geoJsonOverlay[key]);
  //             gisMapComp.activeLayers[key] = true;
  //           }
  //     }
  //     gisMapComp.spinner = false;
  //       resolve(geoJsonOverlay);
  //   });
  // }

  getVECTOROverlays(data, params?) {
    let overlays: any = {};
    for (const key in data) {
      let element = data[key];
      if (element.type === "VECTOR") {
        const overlay: any = {};
        overlay.type = 'vector';
        overlay.name = element.name;
        overlay.component = element.component;
        overlay.layerOptions = {};
        overlay.layerOptions.interactive = true;
        overlay.layerOptions.name = element.layer_name;
        overlay.layerOptions.rendererFactory = (L as any).canvas.tile;
        if (this.validateValue(element.cql_filter))
          overlay.layerOptions.cql_filter = element.cql_filter;
        let kwaramGeo = false;
        if (element.layeroptions_name == 'tamilnadu:mitank_polygon_layer' ||
        element.layeroptions_name == 'tamilnadu:tnwrims_mitank_polygon_layer' ||
          element.layeroptions_name == "kaleshwaram:corewris_ts_complete_basin" ||
          element.layeroptions_name == "kaleshwaram:corewris_ts_complete_sub_basin_updated" ||

          element.layeroptions_name == "kaleshwaram:corewris_godavari_basin_new" ||
          element.layeroptions_name == "kaleshwaram:corewris_godavari_sub_basin" ||

          element.layeroptions_name == "kaleshwaram:kwaram_sub_command_area" ||
          element.layeroptions_name == "kaleshwaram:kwaram_command_district" ||
          element.layeroptions_name == "kaleshwaram:kwaram_command_mandal" ||

          element.layeroptions_name == "HEATWAVE:AP_DISTRICTS" ||
          element.layeroptions_name == "HEATWAVE:AP_MANDAL" ||
          element.layeroptions_name == "HEATWAVE:AP_VILLAGES" ||
          element.layeroptions_name == "HEATWAVE:AP_BASIN" ||
          element.layeroptions_name == "HEATWAVE:AP_SUBBASIN"
        ) {
          kwaramGeo = true;
        }
        overlay.url = this.getVectorLayerURL(element.layeroptions_name, overlay.layerOptions.cql_filter, null, kwaramGeo);

        overlay.layerOptions.view = element.view;
        overlay.layerOptions.minZoom = element.layeroptions_min_zoom;
        overlay.layerOptions.maxZoom = element.layeroptions_max_zoom;
        overlay.layerOptions.pane = element.layeroptions_pane;
        overlay.layerOptions.visible = element.visible;
        overlay.layerOptions.type = LAYER_TYPES.VECTOR_LAYER;
        // overlay.layerOptions.component = this.params.component;
        if (element.component) {
          overlay.layerOptions.component = element.component;
        }
        overlay.layerOptions.key = key;
          // overlays[key] = overlay;
        if (this.validateValue(element.source))
          overlay.layerOptions.source = element.source;
        if (this.validateValue(element.dashboardView))
          overlay.layerOptions.dashboardView = element.dashboardView;
        if (this.validateValue(element.hasLegend))
          overlay.layerOptions.hasLegend = element.hasLegend;
        if (this.validateValue(element.legendName))
          overlay.layerOptions.legendName = element.legendName;
        overlay.layerOptions.group = element.group;
        overlay.layerOptions.displayName = element.displayName;
        if (this.validateValue(element.layeroptions_show_on_selector) && !element.layeroptions_show_on_selector)
          overlay.layerOptions.showOnSelector = element.layeroptions_show_on_selector;
        if (this.validateValue(element.group_type)) {
          overlay.layerOptions.groupType = element.group_type
        }
        overlay.layerOptions.vectorTileLayerStyles = {};

        if (element.layer_name == 'AP District Boundaries') {
          // corewris_kwaram_telangana_district
          overlay.layerOptions.vectorTileLayerStyles["AP_DISTRICTS"] = {
            fillColor: "transparent",
            opacity: 0.5,
            // weight: 0.3,
            // color: "#B5B5B5"
            // opacity: 1,
            weight: 1,
            color: "#000000",
            // fill: false,
            interactive: params&&params.component&&params.component=='LI_SCHEME'?false:true
          };
          overlay.layerOptions.getFeatureId = function (feature) {
            return feature.properties.objectid;
          }
        }

        else if (element.layer_name == 'Water Bodies') {
          let polygonLayer = "tnwrims_mitank_polygon_layer_wrd"
          // if(params.hasOwnProperty('type')){
          //   polygonLayer = MITANK_TYPE_CONSTANTS[params['type']]['POLYGON_LAYER_NAME']
          // }
          overlay.layerOptions.vectorTileLayerStyles[polygonLayer] = {
            weight: 2.5,
            fill: true,
            fillColor: '#47b4fa',
            color: '#15397e',
            fillOpacity: 0.8,
            opacity: 1,
            interactive: true
          };
          overlay.layerOptions.getFeatureId = function (feature) {
            return feature.properties.mitank_uuid;
          }
        }
        else if (element.layer_name == 'AP Mandal Boundaries') {
          overlay.layerOptions.vectorTileLayerStyles["AP_MANDAL"] = {
            opacity: 0.5,
            weight: 0.5,
            // color: '#B5B5B5'
            // opacity: 0.95,
            // weight: 0.35,
            color: '#000000',
            interactive: params&&params.component&&params.component=='LI_SCHEME'?false:true
            // interactive: true
          };
          overlay.layerOptions.getFeatureId = function (feature) {
            return feature.properties.objectid;
          }
        } else if (element.layer_name == 'Telangana Village Boundaries') {
          overlay.layerOptions.vectorTileLayerStyles["tamilnadu_villages"] = {
            opacity: 0.5,
            weight: 0.15,
            // color: '#B5B5B5'
            // opacity: 0.95,
            // weight: 0.35,
            color: '#000000',
            // interactive: true
          };
          overlay.layerOptions.getFeatureId = function (feature) {
            return feature.properties.uuid;
          }
        }
        else if (element.layer_name == 'AP Basin') {
          overlay.layerOptions.vectorTileLayerStyles["AP_BASIN"] = {
            fillColor: "transparent",
            opacity: 0.5,
            weight: 1,
            // color: "#B5B5B5"
            // opacity: 1,
            // weight: 1.5,
            color: "#000000",
            // interactive: true

          };

          overlay.layerOptions.getFeatureId = function (feature) {
            return feature.properties.objectid;
          }
        }  else if (element.layer_name == 'Tamilnadu Combined Basin Boundary') {
          overlay.layerOptions.vectorTileLayerStyles["tamilnadu_inflow_forecast_full_basin_v5"] = {
            // fillColor: "transparent",
            opacity: 2,
            weight: 0.3,
            // color: "#B5B5B5"
            // opacity: 1,
            // weight: 1.5,
            color: "#000000",
             interactive: true

          };

          overlay.layerOptions.getFeatureId = function (feature) {
            return feature.properties.uuid;
          }
        }
        else if (element.layer_name == 'AP Subbasin') {
          // corewris_ts_complete_sub_basin
          overlay.layerOptions.vectorTileLayerStyles["AP_SUBBASIN"] = {
            opacity: 0.5,
            weight: 1,
            // color: '#B5B5B5'
            // opacity: 0.95,
            // weight: 0.35,
            color: '#000000',
            // interactive: true
          };

          overlay.layerOptions.getFeatureId = function (feature) {
            return feature.properties.objectid;
          }
        }
        // else if (element.layer_name == 'MI_Tanks') {
        //   let polygonLayer = "tnwrims_mitank_polygon_layer_wrd"
        //   if(params.hasOwnProperty('type')){
        //     polygonLayer = MITANK_TYPE_CONSTANTS[params['type']]['POLYGON_LAYER_NAME']
        //   }

        //   overlay.layerOptions.vectorTileLayerStyles[polygonLayer] = {
        //     // weight: 1.8,
        //     // fill: true,
        //     // fillColor: '#FFCCCC',
        //     // color: '#000000',
        //     // // color: '#013220',
        //     // fillOpacity: 0.5,
        //     // opacity: 1,
        //     // stroke:true,
        //     weight: 1,
        //     fill: true,
        //     fillColor: '#FFCCCC',
        //     color: '#15397e',
        //     // color: '#013220',
        //     fillOpacity: 0.5,
        //     opacity: 1,
        //     pane: 'popUp',
        //     stroke: true,
        //   };

        //   overlay.layerOptions.getFeatureId = function (feature) {
        //     return feature.properties.uuid;
        //   }
        // }
        // else if (element.layer_name == 'Tamilnadu River Layer') {
        //   overlay.layerOptions.vectorTileLayerStyles["tamilnadu_rivers_layer"] = this.WCSriverLayerStyleEvent.bind(this)
        // }
        // else if( element.layer_name ==  'Canal Network'){
        //   overlay.layerOptions.vectorTileLayerStyles["tamilnadu_project_wise_canal_network"] = this.WCSriverLayerStyleEvent.bind(this)
        // }
        if (element.type === 'VECTOR') {
          overlay.key = element;
          overlays[key] = overlay;
        }
      }
    }
    
    return overlays;

  }

  // public WCSriverLayerStyleEvent(properties, zoom){
  //     const style = LischemedssUtilsConstant.RIVER_VECTOR_STYLES;
  //     style.weight = LischemedssUtilsConstant.RIVER_VECTOR_WEIGHT_BASEDON_ZOOM[zoom]
  //     return style;
  // }

getColor(properties, cropColorData_UUID){
  var blockuuid = properties.uuid;
  var colorCode;
  if (cropColorData_UUID && cropColorData_UUID.hasOwnProperty(blockuuid)) {
    colorCode =
    cropColorData_UUID[blockuuid] && cropColorData_UUID[blockuuid] != null
      ? cropColorData_UUID[blockuuid]
      : "#DCDCDC";
    return colorCode;
  } else {
    colorCode = "#808080";
  }
  return colorCode;
}

  getVectorLayerURL(layerName, cqlFilter, layername?, kwaramGeo?) {
    let url: String;
    if (!isNullOrUndefined(kwaramGeo) && kwaramGeo) {
      url = gisIPKwaramGeo + gisStoreName;
    }else {
      url = this.urlConstants.NEW_GEOSERVER_URL + gisVassarlabsStoreName;
    }
    url += '/gwc/service/wmts?layer=' + layerName + '&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=application/x-protobuf;type=mapbox-vector&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}';
    if (this.validateValue(cqlFilter)) {
      url += '&cql_filter=' + cqlFilter;
    }
    return url;
  }

  setVECTOROverlays(mapObj, vectorLayer, submodule?: any, layerList?: any, params?: any,gisMapComp?:any) {
    console.log("params:::", params)
    const layers: any = {};
    for (const key in vectorLayer) {
      const layer = vectorLayer[key];
      const vectorTileLayer = new (L as any).vectorGrid.protobuf(layer.url, layer.layerOptions);
      vectorTileLayer.on({
          mouseover: (e: any) => {
            const layerName = layer['key']['name'];
            let uuid;
            if (layer['key']['name'] === 'STATE' || layer['key']['name'] === 'DISTRICT')
              uuid = e.layer['properties']['objectid']
            else
              uuid = e.layer['properties']['objectid']

            if(layerName=='DISTRICT' && key == "AP District Boundaries"){
              // if(params && params['component']!=VisibilityMapConstants.COMPONENT.RIVER_GAUGE && params['component']!=VisibilityMapConstants.COMPONENT.RESERVOIR)
              // {
              //   const popup = L.popup({ autoPan: false, pane: 'popUpGeoJson', closeButton: false })
              //   let htmlContent;
              //     htmlContent = this.setHtmlContentForDistrictPopup(e['sourceTarget']['properties']);
              //     popup.setLatLng(e['latlng'])
              //       .setContent(htmlContent).openOn(mapObj);
              // }
              
            }
            if (this.params['view']=='ADMIN' || this.params['view']=='BASIN') {  /// added so that style wont be reset
              if (uuid != this.activeFeatureDataId()) {
                vectorTileLayer.setFeatureStyle(uuid, {
                  color: 'black',
                  weight: layer['key']['name'] === 'DISTRICT' || layer['key']['name'] === 'BASIN' ? 1.75 :
                    layer['key']['name'] === 'MANDAL' || layer['key']['name'] === 'SUBBASIN' ? 1.25 : 1.20
                });
              }
            }
            if (key === "MI_Tanks") {
              vectorTileLayer.setFeatureStyle(uuid,
                {
                  weight: 1,
                  fill: true,
                  fillColor: '#FFCCCC',
                  color: '#2CD9C5',
                  fillOpacity: 0.5,
                  opacity: 1,
                  pane: 'popUp',
                  stroke: true,
                }
              )
            }
          },
          mouseout: (e: any) => {
            let uuid;
            if (layer['key']['name'] === 'STATE' || layer['key']['name'] === 'DISTRICT')
              uuid = e.layer['properties']['objectid'];
            else
              uuid = e.layer['properties']['objectid'];
            /// added so that style wont be reset
            if (uuid != this.activeFeatureDataId()) {
              vectorTileLayer.resetFeatureStyle(uuid);
            }

            if (key === "MI_Tanks") {
              vectorTileLayer.resetFeatureStyle();
            }

            // mapObj.closePopup();
          },
          // click: (e: L.LayerEvent) => {
          //  console.log("vector click :: e ::-----",e,params,this.colorStyling);
          //  this.gisUtils.setClickedMapNumber(params['mapid'])
          // //  Object.keys(this.colorStyling).forEach(map=>{
          // //   Object.keys(this.colorStyling[map]).forEach(category=>{
          // //     if(category==e.target.options['displayName'])
          // //       {
          // //         console.log("category",category)
          // //         for (let key in this.colorStyling[map][category]) {
          // //           // let obj = styleObj;
          // //           let obj = {
          // //             uuid: null,
          // //             clr: '#634343',
          // //             // wt: 0.3,
          // //             // opacity: 0.45,
          // //           }
          // //           obj.clr = this.colorStyling[map][category][key];
          // //           obj.uuid = key;
          // //           gisMapComp.colorVectortileslayer(vectorTileLayer, [obj]);
          // //         }
          // //       }
              
          // //     console.log("length ",map,category,Object.keys(this.colorStyling[map][category]).length)
          // //   })
          // //  })
          // //  gisMapComp.injectedService.colorLayers(gisMapComp)
           
          //  if(params['view']=="TN_BASIN_VIEW" && params['component']=="RAINFALL"){
          //     if (!VisibilityMapConstants.FULL_BASIN_UUID_MAPPIND.includes(e['sourceTarget']['properties']['uuid'])){
          //       return ;
          //     }
          //  }
          //   if(this.params['component'] == VisibilityMapConstants.COMPONENT.VGS && e.target.options.name == "Tamilnadu VGS")
          //   {
          //     gisMapComp.injectedService[gisMapComp.otherOptions['onVillageClick']](gisMapComp,e);
          //   }
          //   if(this.params['component'] == VisibilityMapConstants.COMPONENT.DPMS)
          //   {
          //     gisMapComp.injectedService[gisMapComp.otherOptions['onWorkLayerClick']](gisMapComp,e);
          //   }
          //   if(this.params['component'] && this.params['component'] == VisibilityMapConstants.COMPONENT.NOWCAST && (layer['key']['name'] != VisibilityMapConstants.LOCATIONS.DISTRICT && layer['key']['name'] != VisibilityMapConstants.LOCATIONS.BASIN)){
          //     return;
          //   }
          //   if(this.params['component'] == VisibilityMapConstants.COMPONENT.LISCHEMEDSS && e.target.options.name == "Tamilnadu River Layer")
          //   {
          //     gisMapComp.injectedService[gisMapComp.otherOptions['onRiverPointClick']](mapObj,e,gisMapComp);
          //   }
          //   if (isNullOrUndefined(submodule) || submodule != 'WATER_SPREAD' ||
          //     this.params['component'] ) {
          //     if (this.params['component']  &&this.params['component'] != VisibilityMapConstants.COMPONENT.VGS  && this.params['component'] != VisibilityMapConstants.COMPONENT.INDUSTRIALDEMAND && this.params['src']!='TNPWD' &&  !(this.params['component']==VisibilityMapConstants.COMPONENT.RESERVOIR &&(this.params['view']=='ADMIN' || e['target']['options']['name'] == "Telangana Subbasin"))&& !(this.params['component'] == VisibilityMapConstants.COMPONENT.RIVER_GAUGE && (this.params['view']=='ADMIN' || e['target']['options']['name']=="Telangana Subbasin")) && !(this.params['component']==VisibilityMapConstants.COMPONENT.EVAPOTRANSPIRATION && this.params['cType']==VisibilityMapConstants.LOCATIONS.BLOCK && this.params['component']==VisibilityMapConstants.COMPONENT.GEOPORTAL)) {
          //       let locName, pUUID, prevLoc, parentLoc;
          //       if (key.includes('Telangana MiTank Polygon')) {
          //         this.params['locName'] = e['sourceTarget']['properties']['tank_name']
          //         this.params['pUUID'] = e['sourceTarget']['properties']['uuid']
          //         this.params['pType'] = 'MITANK'
          //         this.params['cType'] = 'MITANK'
          //         this.params['actionType'] = 'sensorClick'
          //         this.gisUtils.setSelectedParams(this.params);
          //       }
          //       if(this.params['component'] == 'RAINFALL' && this.params['view'] == 'TN_BASIN_VIEW'){
          //         locName = e['sourceTarget']['properties']['basin'];
          //         pUUID = e['sourceTarget']['properties']['uuid'];
          //         parentLoc = 'TN_BASIN_VIEW'
          //         }
          //       else if(this.params['component'] == 'RIVER_GAUGE' && this.params['view'] == 'TN_BASIN_VIEW'){
          //           console.log("rivergauge ",e['sourceTarget']['properties'])
          //           locName = e['sourceTarget']['properties']['basin'];
          //           pUUID = e['sourceTarget']['properties']['tn_uuid'];
          //           parentLoc = 'TN_BASIN_VIEW'
          //           }
          //       else if(this.params['component'] == 'RESERVOIR' && this.params['view'] == 'TN_BASIN_VIEW'){
          //         console.log("RESERVOIR ",e['sourceTarget']['properties'])
          //         locName = e['sourceTarget']['properties']['basin'];
          //         pUUID = e['sourceTarget']['properties']['tn_uuid'];
          //         parentLoc = 'TN_BASIN_VIEW';
          //         }
          //       else if (e['sourceTarget']['properties']['sub_basin']) {
          //         locName = e['sourceTarget']['properties']['sub_basin'];
          //         pUUID = e['sourceTarget']['properties']['uuid'];
          //         parentLoc = 'BASIN'
          //       }
          //       else if (e['sourceTarget']['properties']['basin']) {
          //         locName = e['sourceTarget']['properties']['basin'];
          //         pUUID = e['sourceTarget']['properties']['uuid'];
          //         parentLoc = 'STATE'
          //       }
          //       else if (e['sourceTarget']['properties']['village']) {
          //         locName = e['sourceTarget']['properties']['village'];
          //         pUUID = e['sourceTarget']['properties']['uuid']
          //         parentLoc = 'BLOCK'
          //       }
          //       else if (e['sourceTarget']['properties']['block'] && params.component != 'WATERAUDIT'||e['sourceTarget']['properties']['block'] && params.component != 'CROP_WATER_DEMAND') {
          //         locName = e['sourceTarget']['properties']['block'];
          //         pUUID = e['sourceTarget']['properties']['uuid']
          //         parentLoc = 'DISTRICT'
          //         if(params['component']=='MITANK')
          //           this.params['iPUUID'] = e['sourceTarget']['properties']['dist_uuid'];
          //       }
          //       else if (e['sourceTarget']['properties']['district']) {
          //         locName = e['sourceTarget']['properties']['district'];
          //         pUUID = e['sourceTarget']['properties']['uuid'];
          //         parentLoc = 'STATE'
          //       }
          //       else if (e['sourceTarget']['properties']['state_uuid']) {
          //         locName = e['sourceTarget']['properties']['name'];
          //         pUUID = e['sourceTarget']['properties']['uuid'];
          //         // parentLoc = 'DISTRICT'
          //         parentLoc = gisMapComp.params && gisMapComp.params['mapid']?e['sourceTarget']['properties']['type']=='TALUK'?'DISTRICT':'TALUK':'DISTRICT';
          //       }
          //       // if(this.params['component']=='CROP_WATER_DEMAND'&&this.params['cType']=="BLOCK"){
          //       //   console.log("paramsgis",params)
          //       //   return;
          //       // }
          //       if (!(e['target']['options']['name'] == 'Telangana Village Boundaries' && this.params['component']=='MITANK') && this.params['view'] != VisibilityMapConstants.VIEWS.PROJECT && this.params['view'] != VisibilityMapConstants.VIEWS.COMBINED_BASIN && !(e['sourceTarget']['properties']['mandal_nam'] && this.params['component'] == 'MITANK' && this.params['pType'] == VisibilityMapConstants.LOCATIONS.MITANK && this.params['cType'] == VisibilityMapConstants.LOCATIONS.MITANK )&& !(this.params['component'] == 'WATERAUDIT'  && this.params['cType'] == 'BLOCK'|| this.params['pType']=='SUBBASIN') && !(this.params['component'] == 'WATERAUDIT'  && this.params['cType'] == 'SUBBASIN')&& !(this.params['component'] == 'SOILMOISTURE'  && (this.params['pType'] == 'BLOCK' || this.params['pType'] == 'SUBBASIN')) && !(params.component=='DRINKINGWATERSTRESS' && this.params['cType']=='VILLAGE') || this.params['component']==VisibilityMapConstants.COMPONENT.GROUNDWATERQUALITY &&!(this.params['component']==VisibilityMapConstants.COMPONENT.WCSTRUCTURES && (this.params['cType']=='VILLAGE'))&&!(this.params['component'] == 'CROP_WATER_DEMAND'  && this.params['cType'] == 'BLOCK'))
          //         {
          //           if(!(this.params['component'] == 'NDVI'  && this.params['cType'] == 'VILLAGE' && this.params['pType'] == 'BLOCK' ) && !(params.component == VisibilityMapConstants.COMPONENT.EVAPOTRANSPIRATION && this.params['pType'] == "BASIN") && !(params.component == "VILLAGE_WB" && this.params['cType'] == "VILLAGE")){
          //             if(this.params['component']=='GWMS')
          //               {
          //                 if(gisMapComp && gisMapComp.params &&  gisMapComp.params['mapid'])
          //                  this.onLocationClick(locName,pUUID,parentLoc,prevLoc,gisMapComp.params,gisMapComp.params['mapid'])
          //                 else
          //                 this.onLocationClick(locName,pUUID,parentLoc,prevLoc,gisMapComp.params);
          //               }
          //             else
          //             this.onLocationClick(locName, pUUID, parentLoc, prevLoc);
          //           }
          //         }
          //       else if(this.params['component']=='SOILMOISTURE' && this.params['view'] == VisibilityMapConstants.VIEWS.COMBINED_BASIN){
          //         parentLoc = 'COUNTRY';
          //         this.onLocationClick(locName, pUUID, parentLoc, prevLoc);
          //       }
          //       // this.onLocationClick(locName, pUUID, parentLoc, prevLoc);
          //     }
          //   }
          // },
          
        })


      layers[key] = vectorTileLayer;
      if (layer.layerOptions.visible == true) {
        if (layerList) {
          if (mapObj.hasLayer(layerList[key]))
            mapObj.removeLayer(layerList[key])
        }
        mapObj.addLayer(layers[key]);
      }
    }
    return layers;
  }

  navigationFromLayers(layer) {
    let that = this;
    layer.on('click', (e: any) => {
      let locName, pUUID, prevLoc, parentLoc;
      if (layer.options.name.includes('Telangana MiTank Polygon')) {
        this.params['locName'] = e['sourceTarget']['properties']['tank_name']
        this.params['pUUID'] = e['sourceTarget']['properties']['uuid']
        this.params['pType'] = 'MITANK'
        this.params['cType'] = 'MITANK'
        this.params['actionType'] = 'sensorClick'
        this.gisUtils.setSelectedParams(this.params);
      }
      // if (e['sourceTarget']['properties']['sub_basin']) {
      //   locName = e['sourceTarget']['properties']['sub_basin'];
      //   pUUID = e['sourceTarget']['properties']['uuid'];
      //   parentLoc = 'BASIN'
      // }
      // else if (e['sourceTarget']['properties']['ba_name']) {
      //   locName = e['sourceTarget']['properties']['ba_name'];
      //   pUUID = e['sourceTarget']['properties']['uuid'];
      //   parentLoc = 'STATE'
      // }
      // if (e['sourceTarget']['properties']['mandal_nam']) {
      //   locName = e['sourceTarget']['properties']['mandal_nam'];
      //   pUUID = e['sourceTarget']['properties']['loc_uuid']
      //   parentLoc = 'DISTRICT'
      // }
      // else
      //   if (e['sourceTarget']['properties']['dist_name']) {
      //     locName = e['sourceTarget']['properties']['dist_name'];
      //     pUUID = e['sourceTarget']['properties']['loc_uuid'];
      //     parentLoc = 'STATE'
      //   }
      if (e['sourceTarget']['properties']['sub_basin']) {
        locName = e['sourceTarget']['properties']['sub_basin'];
        pUUID = e['sourceTarget']['properties']['uuid'];
        parentLoc = 'BASIN'
      }
      else if (e['sourceTarget']['properties']['basin']) {
        locName = e['sourceTarget']['properties']['basin'];
        pUUID = e['sourceTarget']['properties']['uuid'];
        parentLoc = 'STATE'
      }
      else if (e['sourceTarget']['properties']['village']) {
        locName = e['sourceTarget']['properties']['village'];
        pUUID = e['sourceTarget']['properties']['uuid']
        parentLoc = 'BLOCK'
      }
      else if (e['sourceTarget']['properties']['block'] ) {
        locName = e['sourceTarget']['properties']['block'];
        pUUID = e['sourceTarget']['properties']['uuid']
        parentLoc = 'DISTRICT'
      }
      else if (e['sourceTarget']['properties']['district']) {
        locName = e['sourceTarget']['properties']['district'];
        pUUID = e['sourceTarget']['properties']['uuid'];
        parentLoc = 'STATE'
      }
      this.onLocationClick(locName, pUUID, parentLoc, prevLoc);
    });
  }
  activeFeatureDataId() {
    if(this.params['component'] == 'GWMS'){
      return this.activeFeatureData['uuid'];
    }else{
      return this.activeFeatureData["external_i"];
    }
  }

  onLocationClick(locName, pUUID, parentLoc?, clickType?,params?,mapid?) {

    let options = this.params; 
    if(params)
       options=params
    if(mapid)
      options= {...params};
    options['locName'] = locName;
    options['prevpUUID'] = options['pUUID'];
    options['iPUUID'] = options['iPUUID'] ?  options['iPUUID'] : options['pUUID'];
    options['pUUID'] = pUUID;
    options['pType'] = this.utilsSrv.getChildTypeForGivenParentType(parentLoc ? parentLoc : options['pType'], options['locationTypeList']);
    options['cType'] = this.utilsSrv.getChildTypeForGivenParentType(options['pType'], options['locationTypeList']);
    options['actionType'] = clickType ? clickType : 'mapClick';
    if (this.params['component']=='MITANK' ){
      if (this.params['pType']!="MITANK"||this.params['cType']!="MITANK")
      this.gisUtils.setSelectedParams(options);
    }else if(this.params['component']=='CROP_WATER_DEMAND'){
      if (this.params['pType']!="BLOCK"||this.params['cType']!="BLOCK")
      this.gisUtils.setSelectedParams(options);

    }
    else{
       this.gisUtils.setSelectedParams(options);
    }
    // if (parentLoc != 'BLOCK')
      
  }

  setPopupHtmlContent(locationName, locationValue) {
    let htmlString = `<div class="popup-table-section">
        <div class="card-body p-0">
        <table class="table table-sm m-0 table-bordered ">
            <tr>
              <td> ${locationValue} </td>
            </tr>
        </table>
      </div>
      </div>`
    return htmlString;
  }

  /* Usually the any day begins from 8:30 AM morning till 8:59:59 AM of next morning this method checks
   if Date is falling under Rainfall date (8:30 to 8:59:59) or not else subtractone day from current date */
  selectDateonBasisOfRFtime(date) {
    var currentDate = new Date();
    // console.log(currentDate);
    currentDate.setHours(0, 0, 0, 0);
    var todayRFstartTs = currentDate.getTime();
    todayRFstartTs = todayRFstartTs + (8.5 * 3600000);
    var currentTs = new Date().getTime();
    if (currentTs < todayRFstartTs) {
      //subtract one day
      date.setDate(date.getDate() - 1);
    }
    return date;

  }
  getActualHeatMapDateList() {
    var currentDate = new Date();
    currentDate = this.selectDateonBasisOfRFtime(currentDate);
    let startdate = moment(currentDate).format("YYYYMMDD");
    let yesterday = moment(currentDate).subtract(1, "days").format("YYYYMMDD");
    let dbYesterday = moment(currentDate).subtract(2, "days").format("YYYYMMDD");
    let dateList = {};
    var set1 = []; set1.push(startdate); set1.push(startdate); // today-today
    var set2 = []; set2.push(yesterday); set2.push(yesterday); // yesterday -yesterday
    var set3 = []; set3.push(dbYesterday); set3.push(dbYesterday); // daybeforeYes - daybeforeYes
    var set4 = []; set4.push(dbYesterday); set4.push(startdate); // last 3 day
    dateList['Today'] = set1; dateList['Yesterday'] = set2; dateList['Day Before Yesterday'] = set3; dateList['Last 3 Day Cummulative'] = set4;
    return dateList;
  }

  getRangeRainfallLegendData(data) {
    var legend = {};
    legend['Units'] = 'mm';
    legend['colorValues'] = [];
    if (data) {
      var obj;
      var count = 0;;
      var text;
      for (var level in data) {
        if (level) {
          count++;
          obj = {};
          text = level;
          if (data[level] == '006B3C')
            data[level] = '#006B3C';
          if (count > 4) {
            if (count === (Object.keys(data).length) && level != "1.0E8") {
              obj = {
                'backgroundColor': data[level],
                // 'color': '#FFFFFF',
                'color': '#000000',
                'text': '>=' + text
              };
              if (obj.backgroundColor == '#003300') {
                obj.color = '#FFFFFF';
              }
              legend['colorValues'].push(obj);
              return legend;
            }
            if (count === ((Object.keys(data).length) - 1) && level == "1500.0") {
              obj = {
                'backgroundColor': data[level],
                // 'color': '#FFFFFF',
                'color': '#000000',
                'text': '>=' + text
              };
              if (obj.backgroundColor == '#003300') {
                obj.color = '#FFFFFF';
              }
              legend['colorValues'].push(obj);
              return legend;
            }
            obj = {
              'backgroundColor': data[level],
              // 'color': '#FFFFFF',
              'color': '#000000',
              'text': text
            };
            if (obj.backgroundColor == '#003300') {
              obj.color = '#FFFFFF';
            }
            // prevLevel = text;
          }
          else {
            obj = {
              'backgroundColor': data[level],
              'color': '#000000',
              // 'color': '#FFFFFF',
              'text': text
            };
            if (obj.backgroundColor == '#003300') {
              obj.color = '#FFFFFF';
            }
          }
          legend['colorValues'].push(obj);
        }
      };
    }
    return legend;
  }



  setImageLayers(mapObj, imageLayers, layerList) {
    // if(mapObj.hasLayer(layerList['Rainfall Heatmap']))
    //   mapObj.removeLayer(layerList['Rainfall Heatmap']);
    // console.log("\n In setImageLayers:: imageLayers",imageLayers,"\n layerList",layerList);
    let layers = {};
    for (const key in imageLayers) {
      if (imageLayers.hasOwnProperty(key)) {
        const layer: any = imageLayers[key];
       if(!isNullOrUndefined(layer.url))
       {
        let imglayer = L.imageOverlay(layer.url, layer.bounds, layer.layerOptions);
        // let imglayer = L.imageOverlay(layer.url, layer.bounds, layer.layerOptions);
        // console.log("\n key ",key,"\n imglayer",imglayer);
        layers[key] = imglayer;
        if (mapObj.hasLayer(layerList[key]))
          mapObj.removeLayer(layerList[key]);
        if (layer.layerOptions.visible === true) {
          mapObj.addLayer(layers[key])
          // imglayer.addTo(mapObj);
        }
      }
      }
    }
    return layers;
  }

  setImageLayersInflowForecast(mapObj: any, imageLayers: any, layerList: any) {
    let layers = {};
    for (const key in imageLayers) {
      if (imageLayers.hasOwnProperty(key)) {
        const layer: any = imageLayers[key];

        let imglayer;
        layer['layerOptions'] = layer['options']
        layer['url'] = layer['imageUrl'];
        imglayer = new (L as any).imageTransform(layer['url'], layer.imageBounds, layer.layerOptions);
        layers[key] = imglayer;
        if (mapObj.hasLayer(layerList[key]))
          mapObj.removeLayer(layerList[key]);
        if (layer.options.visible === true) {
          mapObj.addLayer(layers[key])
        }

      }
    }
    return layers;
  }

  setImageLayersNew(mapObj, imageLayers, layerList, imageData) {
    let options = {
      opacity: 0.8,
      pane: 'heatMap',
      minZoom: 6,
      maxZoom: 15,
      clip: imageData['bbox']
    };
    let data = this.setHeatMapData(imageData['heatmapData'])
    let layers = {};
    for (const key in imageLayers) {
      if (imageLayers.hasOwnProperty(key)) {
        const layer: any = imageLayers[key];
        if (data['url'] != null && data['url'] != undefined) {
          var anchors = this.getImageBounds(data['bounds']);
          // layer['layer'] = L.imageTransform('assets/SampleCSV_imgs/wqValues_windspeed_432382632516.png',anchors,options);
          // console.log(data['url'],anchors,options)
          let imglayer = (L as any).imageTransform(data['url'], anchors, options);
          layers[key] = imglayer;
          // console.log(imglayer,"imglayer")
          layers[key]['options'] = Object.assign(layer['layerOptions'], options)
          if (mapObj.hasLayer(layerList[key]))
            mapObj.removeLayer(layerList[key]);
          if (layer.layerOptions.visible === true) {
            mapObj.addLayer(layers[key])
          }
        }
      }
    }
    return layers;
  }

  setHeatMapData(data) {
    let obj = {};
    let imageUrl = {};
    let imageBounds = [];
    imageUrl = data['heatMapImage'];
    let latlongs = [];
    latlongs.push(data['heatMapImageBound']['southWest']['latitude']);
    latlongs.push(data['heatMapImageBound']['southWest']['longitude']);
    imageBounds.push(latlongs);
    latlongs = [];
    latlongs.push(data['heatMapImageBound']['northEast']['latitude']);
    latlongs.push(data['heatMapImageBound']['northEast']['longitude']);
    imageBounds.push(latlongs);
    obj['url'] = imageUrl;
    obj['bounds'] = imageBounds;
    return obj;
  }

  getBlockBoundsForType(basinName) {
    var obj = {
      "TELANGANA": [[15.559452, 76.832565]
        , [20.16651, 81.67520]],
      "GODAVARI": [[14.305, 72.898], [24.51, 83.635]],
      "TAMILNADU": [[8.079404, 76.232088], [13.56437, 80.34481]],
      "TN_BASIN_VIEW": [[ 13.65889, 80.33734],[8.082904,75.488872]],
      "COMBINED_BASIN" : [[17.5250000000000270,80.0708333333333542,],[23.6083333336164856,88.1964006202573501]]
    }
    return obj[basinName];
  }

  removeSrcWiseLayer(activelayers, mapObj, srcType?) {
    for (const layer in activelayers) {
      if (activelayers[layer].layerOptions.srcType === 'SRC'
        || activelayers[layer].layerOptions.srcType === 'TIME') {
        if (mapObj.hasLayer(activelayers[layer]))
          mapObj.removeLayer(activelayers[layer])
      }
    }
    return activelayers;
  }
  createImageLayersOverlays(imageData, layersList, basinName, legendData?) {
    var overlays = {};
    for (const key in layersList) {
      if (layersList.hasOwnProperty(key)) {
        const value = layersList[key];
        let overlay: any = {};
        overlay.name = value.name;
        overlay.type = 'image';
        overlay.layerOptions = {};
        overlay.layerOptions.name = value.name;
        if (this.validateValue(imageData[overlay.name]))
          overlay.bounds = this.getBlockBoundsForType(basinName)
        if (this.validateValue(value.name))
          overlay.bounds = this.getBlockBoundsForType(basinName)
        if (this.validateValue(value.group_type)) {
          overlay.layerOptions.groupType = value.group_type
        }
        if (this.validateValue(value.component))
          overlay.layerOptions.component = value.component;
        if (this.validateValue(value.hasLegend))
          overlay.layerOptions.hasLegend = value.hasLegend;
        if (this.validateValue(value.key))
          overlay.layerOptions.key = value.key;
        if (this.validateValue(value.legendName))
          overlay.layerOptions.legendName = value.legendName;
        if (this.validateValue(value.legendData))
          overlay.layerOptions.legendData = legendData ? legendData : value.legendData;
        if (this.validateValue(value.subgroup))
          overlay.layerOptions.subgroup = value.subgroup;
        if (this.validateValue(value.displayName))
          overlay.layerOptions.displayName = value.displayName;
        if (this.validateValue(value.visible))
          overlay.layerOptions.visible = value.visible;
        if (this.validateValue(value.group))
          overlay.layerOptions.group = value.group;
        if (this.validateValue(value.type))
          overlay.layerOptions.type = value.type;
        if (this.validateValue(value.layeroptions_name))
          overlay.layerOptions.layerName = value.layeroptions_name;
        if (this.validateValue(value.layeroptions_pane)) {
          overlay.layerOptions.pane = value.layeroptions_pane;
        }
        if (this.validateValue(value.layeroptions_min_zoom))
          overlay.layerOptions.minZoom = value.layeroptions_min_zoom;
        if (this.validateValue(value.layeroptions_max_zoom))
          overlay.layerOptions.maxZoom = value.layeroptions_max_zoom;
        if (this.validateValue(value.layeroptions_show_on_selector) && !value.layeroptions_show_on_selector)
          overlay.layerOptions.showOnSelector = value.layeroptions_show_on_selector;
        if (value.type === 'HEATMAP' && !this.validateValue(value.image_path)) {
          if (this.validateValue(imageData[overlay.name])) {
            overlay.url = imageData[overlay.name].url
            overlays[key] = overlay;
          }
          else if(this.validateValue(value.url))
          {
            overlay.url = value.url
            overlays[key] = overlay;
          }
          else {
            overlay.url = imageData[value.layeroptions_name];
            overlays[key] = overlay;
          }
        } else if (value.type === 'HEATMAP' && this.validateValue(value.image_path)) {
          overlay.url = value.image_path;
          overlays[key] = overlay;
        }
        if (this.validateValue(value.info)) {
          overlay.layerOptions.info = value.info
        }
      }
    }
    return overlays;
  }

  setGeojsonOverlaysUsinguGeoJSONLayer(map: any, GEOJSONLayers: any) {
    const layers: any = {};
    for (const key in GEOJSONLayers) {
      const layer = GEOJSONLayers[key];
      layer.layerOptions.endpoint = this.getUrlForGeojsonLayer(layer.layerOptions.layers);
      layer.layerOptions.enctype = 'urlencoded';
      layer.layerOptions.style = this.stylingforGeoJson;
      let geojsonTileLayer = new (L as any).uGeoJSONLayer(layer.layerOptions);
      layers[key] = geojsonTileLayer;
      if (layer.layerOptions.visible) {
        map.addLayer(geojsonTileLayer);
      }
    }
    return layers;
  }

  getUrlForGeojsonLayer(layeroptionsName) {
    let url = '';
    url = this.urlConstants.NEW_GEOSERVER_URL + 'tamilnadu/' + 'ows';
    url += '?service=WFS&version=1.0.0&request=GetFeature&typeName=' + layeroptionsName;
    url += '&outputFormat=application/json';
    return url;
  }

  stylingforGeoJson(feature) {
    return {
      weight: 1.8,
      fill: true,
      fillColor: '#FFCCCC',
      color: '#000000',
      fillOpacity: 0.5,
      opacity: 1,
      pane: 'WA'
    };
  }


  getNDayListInFormat(referenceTS, noOfDays, offset) {
    if (referenceTS == null || referenceTS == undefined) {
      referenceTS = new Date().getTime();
    }
    var dayList = [];
    for (var i = offset; i < (noOfDays + offset); i++) {
      var day;
      var currDay = new Date(referenceTS + (i * 24 * 60 * 60 * 1000));
      var date = (currDay.getDate() > 9) ? currDay.getDate() : "0" + currDay.getDate();
      var month = ((currDay.getMonth() + 1) > 9) ? (currDay.getMonth() + 1) : "0" + (currDay.getMonth() + 1);
      var year = currDay.getFullYear();

      day = year.toString() + month.toString() + date.toString();
      dayList.push(day);
    }

    return dayList;
  }

  monthShortLabel = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  getReadableDateFromDateString(dateString) {
    var year = dateString.substring(0, 4);
    var month = dateString.substring(4, 6);
    var day = dateString.substring(6, 8);

    var date = new Date(year, month - 1, day);

    return day + "-" + this.monthShortLabel[date.getMonth()] + "-" + year
  }

  public getFeatureInfo(latlng, layer, map) {
    let url = this.getFeatureInfoUrl(latlng, layer, map);
    return this.http.get(url).pipe(
      catchError((err) => {
        return EMPTY;
      })
    );
  }
  getElevationCropGrowthFeatureInfo(latlng, layer, map, Dates) {
    let point = map.latLngToContainerPoint(latlng, map.getZoom());
    let size = map.getSize();
    let url = environment.url.NEW_GEOSERVER_URL+'wms?SERVICE=WMS&VERSION=' + layer.wmsParams.version +
      '&REQUEST=GetTimeSeries&FORMAT=' + layer.wmsParams.format + '&TIME=' + Dates[Dates.length - 1] + '/' + Dates[0] + '&' +
      'QUERY_LAYERS=' + layer.wmsParams.layers + '&STYLES&LAYERS=' + layer.wmsParams.layers + '&INFO_FORMAT=text%csv&FEATURE_COUNT=150&X=' + point.x + '&Y=' + point.y +
      '&SRS=EPSG%3A4326&WIDTH=' + Math.floor(size.x) + '&HEIGHT=' + Math.floor(size.y) + '&BBOX=' + map.getBounds().toBBoxString();
    return this.http.get(url, { responseType: 'text' });

  }
  public getFeatureInfoUrl(latlng, layer, map) {

    // if(!isNullOrUndefined(latlng.latlng)){
    //   latlng = latlng.latlng
    // }

    let point = map.latLngToContainerPoint(latlng, map.getZoom());
    let size = map.getSize();
    let params = {
      request: 'getFeatureInfo',
      service: 'WMS',
      srs: 'EPSG:4326',
      transparent: true,
      version: layer ? layer.wmsParams.version : '',
      format: layer ? layer.wmsParams.format : '',
      bbox: map.getBounds().toBBoxString(),
      height: Math.floor(size.y),
      width: Math.floor(size.x),
      layers: layer ? layer.wmsParams.layers : '',//queryLayers.join(','),
      query_layers: layer ? layer.wmsParams.layers : '',//queryLayers.join(','),
      info_format: 'application/json',
      feature_count: 50,
      CQL_FILTER: layer ? (layer.wmsParams.cql_filter ? layer.wmsParams.cql_filter : '1=1') : ''
    };
    params[params.version === '1.3.0' ? 'i' : 'x'] = Math.floor(point.x);
    params[params.version === '1.3.0' ? 'j' : 'y'] = Math.floor(point.y);
    let url = layer._url + L.Util.getParamString(params, layer._url, true);
    return url;
  }

  public getFeatureInfoForGivenPoint(point, bboxString, size, layer) {
    let url = this.getFeatureInfoUrlForGivenPoint(point, bboxString, size, layer);
    return this.http.get(url).pipe(
      catchError((err) => {
        return EMPTY;
      })
    );
  }
  public getFeatureInfoUrlForGivenPoint(point, bboxString, size, layer) {
    // let point = map.latLngToContainerPoint(event.latlng, map.getZoom());
    let params = {
      request: 'getFeatureInfo',
      service: 'WMS',
      srs: 'EPSG:4326',
      transparent: true,
      version: layer.wmsParams.version,
      format: layer.wmsParams.format,
      bbox: bboxString,
      height: Math.floor(size.y),
      width: Math.floor(size.x),
      layers: layer.wmsParams.layers,//queryLayers.join(','),
      query_layers: layer.wmsParams.layers,//queryLayers.join(','),
      info_format: 'application/json',
      feature_count: 50,
      CQL_FILTER: layer.wmsParams.cql_filter ? layer.wmsParams.cql_filter : '1=1'
    };
    params[params.version === '1.3.0' ? 'i' : 'x'] = point.x;
    params[params.version === '1.3.0' ? 'j' : 'y'] = point.y;
    let url = layer._url + L.Util.getParamString(params, layer._url, true);
    return url;
  }

  public getWmsLayerForTime(layerName, date) {
    let wmsLayer = new (L as any).TileLayer.WMS(this.urlConstants.NEW_GEOSERVER_URL + 'tamilnadu/wms', {
      layers: layerName,
      format: 'image/png',
      transparent: true,
      maxZoom: 25,
      minZoom: 5,
      pane: 'base',
      time: date
    });
    return wmsLayer;
  }

  getTimeWmsLayerFromLayerName(layerObj, layerName, date) {

    let wmsLayer = new (L as any).TileLayer.WMS(layerObj._url, {
      layers: layerName,
      format: 'image/png',
      transparent: true,
      maxZoom: 25,
      minZoom: 5,
      pane: 'base',
      time: date,
      timeDimension: true,
      srs: 'EPSG:4326'
    });
    return wmsLayer;
  }



  public emitSourceChangeEvent(source: string) {
    setTimeout(() => {
      this.updateSourceNameSource.next({ "newSource": source });
    }, 2000);
    this.visibilityMiTanksSource = source;
  }

  getVisibilityMiTanksSource() {
    return this.visibilityMiTanksSource;
  }

  getWFSTOptions(workspace, layerName) {
    return {
      url: this.urlConstants.NEW_GEOSERVER_URL + 'ows',
      typeNS: workspace,
      typeName: layerName,
      crs: L.CRS.EPSG4326,
      geometryField: 'geom',
      forceMulti: true,
      style: function (layer) {
        return {
          color: 'blue',
          weight: 2
        }
      }
    };

  }
  getData(url): any {
    return this.http.get(url);
  }


  setHtmlContentForDistrictPopup(popupData) {
    var htmlString = "<html><body>";
    htmlString += '<div class="popup-selection">'
    htmlString += `<div class="card-body p-0">  `
    htmlString +=  `<span class="popup-content">${popupData['district'] || '-'}</span>
   </div>
   </div>`;

    return htmlString;

  }

  depthLayers: Map<string, Map<string, any>> = new Map<string, Map<string, any>>();
  depthLayerOverlays: Map<string, Map<string, any>> = new Map<string, Map<string, any>>();
  sourceWiseAvailableDates: Map<string, any> = new Map();
  map:any;
  removedLayersMap: Map<string, any[]>=new Map();
  parentdepthLayer:any;

  handleLayerControlEvent(actionType,source="SENTINEL_1"){
    if(actionType == 'remove'){
      this.removedLayersMap.set(source,[]);
      if(this.depthLayerOverlays.get(source)!=null){
        this.depthLayerOverlays.get(source).forEach((value, key) => {
          let overlayObj = value;
          if( overlayObj.getContainer().style.display == 'block'){
            this.removedLayersMap.get(source).push(overlayObj);
          }
          overlayObj.getContainer().style.display = 'none';
        });
      }
    }else{
      if(this.removedLayersMap.get(source)!=null){
        for(let overlayObj of this.removedLayersMap.get(source)){
          overlayObj.getContainer().style.display = 'block';
        }
      }
      this.removedLayersMap = new Map();     
    }
    // console.log("\n In handleLayerControlEvent:: removedLayers",this.removedLayers,"\n actionType",actionType,"\n this.depthLayerOverlays",this.depthLayerOverlays);
  }

  getPlayBarOptions(labels){

    let stepsArray=[]
    labels.forEach((label,index)=>{
    let obj:any={'value':Number,'legend':String}
    obj['value']=index+1;
    obj['legend']=label.replace(/-/gi, "/");
    stepsArray.push(obj)
    })
    return {  
      ceil: labels.length,
      floor: 1,
      showSelectionBar: true,
      showTicks: false,
      showTicksValues: false,
      stepsArray: stepsArray,
      getLegend: (value: number): string => {
        let legend = labels[(value - 1) % labels.length];
        return legend.replace(/-/gi, "/"); 
      },
      ticksTooltip: (value: number): string => {
        return  labels[(value - 1) % labels.length];
      },
      translate: (value: number, label: LabelType): string => {
          return '';
      } 
    };
  }

  loadDepthLayers(map,source,dates,layerConfig,level,cqlFilter?){    
    
    this.sourceWiseAvailableDates.set(source, dates);
    this.map = map;
    this.removePreviousLayersFromMap();

    if(level == 'MITANK'){
        this.depthLayers.set(source, new Map());
        this.depthLayerOverlays.set(source, new Map());

        for(let i in dates){

          let date = dates[i];
          let wmsLayers = this.setWMSOverlays(map,this.getApplicationBasedLayer(layerConfig,'WMS',map));
          let depthLayerObj = wmsLayers['Depth_Class'];

          // let formattedDate = date.split("-")[2] + date.split("-")[1] + date.split("-")[0];
          let formattedDate = this.formatDate(date);
          let layercqlFilter = "";
          if(cqlFilter){
            layercqlFilter = cqlFilter + " AND date='"+formattedDate+"' AND state_uuid='e98cd5b7-6556-4c0f-a778-3429e1c14a6b'";
          }
          layercqlFilter += '';//'date='+formattedDate;
          depthLayerObj.wmsParams.cql_filter = layercqlFilter;
          depthLayerObj.wmsParams.viewparams = 'date:'+formattedDate+';department:WRD';

          this.depthLayers.get(source).set(formattedDate,depthLayerObj);
          let overlayObj = this.depthLayers.get(source).get(formattedDate).addTo(map);
          overlayObj.getContainer().style.display = 'none';
          this.depthLayerOverlays.get(source).set(formattedDate,overlayObj);
        }
    }
    else{
      let wmsLayers = this.setWMSOverlays(map,this.getApplicationBasedLayer(layerConfig,'WMS',map));
      let depthLayerObj = wmsLayers['Depth_Class'];
      let formattedDate = this.formatDate(dates[0]);
      let layercqlFilter = "";
      if(cqlFilter){
        layercqlFilter = cqlFilter;//cqlFilter + " AND ";
      }
      layercqlFilter += ''//'date='+formattedDate;
      depthLayerObj.wmsParams.cql_filter = layercqlFilter;
      this.parentdepthLayer = depthLayerObj;
    }

  }

  formatDate(date:any){
    return date.split("-")[2] + date.split("-")[1] + date.split("-")[0];
  }


  showDepthClassLayer(date: any, source: string, value, prevValue, instance,level) {
    
    if(level != 'MITANK'){
      this.showParentDepthClassLayer(date,instance);
      return;
    }
    if(this.removedLayersMap.size != 0)
      return;
    let formattedDate = this.formatDate(date);
    if (prevValue && prevValue != 0) {
      this.depthLayerOverlays.get(source).get(this.formatDate(this.sourceWiseAvailableDates.get(source)[prevValue - 1])).getContainer().style.display = 'none';
    }
    if (instance.nextValue && instance.nextValue != 0) {
      this.depthLayerOverlays.get(source).get(this.formatDate(this.sourceWiseAvailableDates.get(source)[instance.nextValue - 1])).getContainer().style.display = 'none';
    }

    this.depthLayerOverlays.get(source).get(formattedDate).getContainer().style.display = 'block';
    this.depthLayerOverlays.get(source).get(this.formatDate(this.sourceWiseAvailableDates.get(source)[prevValue - 1])).getContainer().style.removeProperty('clip');
    instance.prevValue = instance.value;
    // console.log("\n In showDepthClassLayer :: this.depthLayerOverlays", this.depthLayerOverlays, "\n  this.depthLayers", this.depthLayers, "\n this.depthLayerOverlays.get(formattedDate)", this.depthLayerOverlays.get(formattedDate), "\n formattedDate", formattedDate);
    instance['currentLayer'] = this.depthLayerOverlays.get(source).get(formattedDate);

  }

  showParentDepthClassLayer(date: any, instance) {
    
    if(this.map.hasLayer(this.parentdepthLayer))
      this.map.removeLayer(this.parentdepthLayer);
    let filter = this.parentdepthLayer.wmsParams.cql_filter;
    let formattedDate = this.formatDate(date);
    
    this.parentdepthLayer.wmsParams.cql_filter = filter.split("date=")[0] + "date=" + formattedDate;
    this.parentdepthLayer.addTo(this.map)
    instance['currentLayer'] = this.parentdepthLayer;

  }


  clip(map,source,rangeValue,value,prevValue,instance) {    

    let nw = map.containerPointToLayerPoint([0, 0]),
    se = map.containerPointToLayerPoint(map.getSize());
    let clipX = nw.x + (se.x - nw.x) * rangeValue;

    if((prevValue < value && prevValue <= this.sourceWiseAvailableDates.get(source).length) || (prevValue == this.sourceWiseAvailableDates.get(source).length && value == 1)){
      if(this.depthLayerOverlays.get(source).get(this.formatDate(this.sourceWiseAvailableDates.get(source)[prevValue-1])).getContainer().style.display == 'block'){
        this.depthLayerOverlays.get(source).get(this.formatDate(this.sourceWiseAvailableDates.get(source)[prevValue-1])).getContainer().style.display = 'none';
        this.depthLayerOverlays.get(source).get(this.formatDate(this.sourceWiseAvailableDates.get(source)[prevValue-1])).getContainer().style.removeProperty('clip');
      }
    }
    
    // if(rangeValue >= 1){
    //   // this.depthLayerOverlays.get(this.formatDate(this.sourceWiseAvailableDates.get(source)[value - 1])).getContainer().style.display = 'block';   
    // }

    this.depthLayerOverlays.get(source).get(this.formatDate(this.sourceWiseAvailableDates.get(source)[value-1])).getContainer().style.clip = 'rect(' + [nw.y, se.x, se.y, clipX].join('px,') + 'px)';
    this.depthLayerOverlays.get(source).get(this.formatDate(this.sourceWiseAvailableDates.get(source)[value % this.sourceWiseAvailableDates.get(source).length])).getContainer().style.clip = 'rect(' + [nw.y, clipX, se.y, nw.x].join('px,') + 'px)';
    let newLayerContainer = this.depthLayerOverlays.get(source).get(this.formatDate(this.sourceWiseAvailableDates.get(source)[value % this.sourceWiseAvailableDates.get(source).length])).getContainer();
    if(this.depthLayerOverlays.get(source).get(this.formatDate(this.sourceWiseAvailableDates.get(source)[value % this.sourceWiseAvailableDates.get(source).length])).getContainer().style.display == 'none' && rangeValue >= 0.01){
      newLayerContainer.style.opacity = 0;
      this.depthLayerOverlays.get(source).get(this.formatDate(this.sourceWiseAvailableDates.get(source)[value % this.sourceWiseAvailableDates.get(source).length])).getContainer().style.display = 'block';
      setTimeout(()=>{
        newLayerContainer.style.opacity = 1;
      },100);
    }
    instance['currentLayer'] = this.depthLayerOverlays.get(this.sourceWiseAvailableDates.get(source)[value % this.sourceWiseAvailableDates.get(source).length]);
    instance.prevValue = instance.value;  
    instance.nextValue = (value+1) % this.sourceWiseAvailableDates.get(source).length;

  }

  onUserChange(value,source,prevValue,instance,level){
    this.onPause(instance);
    this.showDepthClassLayer(this.sourceWiseAvailableDates.get(source)[value-1],source,value,prevValue,instance,level);
  }


  animationValueChange(rangeValue,source,value,prevValue,instance){
    this.clip(this.map,source,rangeValue,value,prevValue,instance);     
  }

  onPlay(instance,source){

    instance.interval = setInterval(() => {
      instance.prevValue = instance.value;
      instance.value = instance.value % this.sourceWiseAvailableDates.get(source).length + 1;
    }, 3000);
    
    instance.animateInterval = setInterval(()=>{
      instance.rangeValue += 0.025;
      this.clip(this.map,source,instance.rangeValue,instance.value,instance.prevValue,instance);     
      // instance.prevValue = instance.value;
      if(instance.rangeValue >= 1)
        instance.rangeValue = 0;
    },80);

  }

  onPause(instance){
    clearInterval(instance.interval);    
    clearInterval(instance.animateInterval);
  }

  removePreviousLayersFromMap(){ 
      for(let entry of Array.from(this.depthLayers.entries())){     
          for(let subentry of Array.from(this.depthLayers.get(entry[0]).entries()))
            this.map.removeLayer(this.depthLayers.get(entry[0]).get(subentry[0]));
        }
        this.removedLayersMap = new Map();
      if(this.parentdepthLayer && this.map.hasLayer(this.parentdepthLayer))
        this.map.removeLayer(this.parentdepthLayer);
    
  }

  hideAllLayers(source){
    let count = 1;
    this.depthLayerOverlays.get(source).forEach((value, key) => {
      let overlayObj = value;
      if(this.removedLayersMap.size != 0 && count == 1){
        this.removedLayersMap.set(source,[]);
        this.removedLayersMap.get(source).push(value);
        count++;
      }
      overlayObj.getContainer().style.display = 'none';
      overlayObj.getContainer().style.removeProperty('clip');
    });
  }

  addSrcWiseGEOJSONLayers(layerList, gisMapComp, params) {
    let geoJsonLayersBasedOnView = gisMapComp.gisDataService.getApplicationBasedLayer(layerList, LAYER_TYPES.GEOJSON_LAYER);
    geoJsonLayersBasedOnView = this.addSourceWiseLayers(gisMapComp, geoJsonLayersBasedOnView, params);
    gisMapComp.addSrcWiseGEOJSONLayers(geoJsonLayersBasedOnView);
  }

  addSrcWiseWMSLayers(layerList, gisMapComp, params) {
    let wmsLayersBasedOnView = gisMapComp.gisDataService.getApplicationBasedLayer(layerList, LAYER_TYPES.WMS_LAYER);
    wmsLayersBasedOnView = this.addSourceWiseLayers(gisMapComp, wmsLayersBasedOnView, params);
    gisMapComp.addSrcWiseWMSLayers(wmsLayersBasedOnView);
  }
  addSourceWiseLayers(gisMapComp, layerList, params) {
    let layers = {};
    for (var i in layerList) {
      layers[i] = layerList[i];
      gisMapComp.activeLayers[i] = layerList[i].layerOptions.visible;
    }
    return layers;
  }

  addSrcWiseVECTORLayers(layerList: any, gisMapComp: any, params: any) {
    let vectorLayersBasedOnView = gisMapComp.gisDataService.getApplicationBasedLayer(layerList, LAYER_TYPES.VECTOR_LAYER);
    vectorLayersBasedOnView = this.addSourceWiseLayers(gisMapComp, vectorLayersBasedOnView, params);
    gisMapComp.addSrcWiseVECTORLayers(vectorLayersBasedOnView);
  }

  async getSrcWiseLayers(gisMapComp) {
    let params = gisMapComp.params;
    // this.gisUtilsSrv.getInflowOptions().subscribe((options : any)=>{
    //   this.inflowOptions  = options ? options : this.inflowOptions;
    //   this.inflowOptions['selectedDate'] = (options['selectedDate'] != '' && options['selectedDate']!=undefined) ? options['selectedDate'] : this.utils.getCurrentInflowTimestep();
    // })
    // this.getRiverNetworkData(params)    // river network coloring based on flow
    if (params['actionType'] == 'filter') {
      var layerList = [];
      for (let layer in LAYER_LIST[params['dashboardView']]) {
        let list = LAYER_LIST[params['dashboardView']][layer];
        layerList[layer] = list;
      }
      // if(isEmptyObject(this.reservoirData) && isEmptyObject(this.rivergaugeData) && isEmptyObject(this.miTanksData) && isEmptyObject(this.miTanksMandalData)) {
        gisMapComp.showThrobber = true ;
        await this.getMetaData(params); // for getting all points meta data of selected full basin.
        // this.miTanksData = await this.getMiTanksData(params);
        // this.miTanksMandalData = await this.getMiTanksMandalData(params,gisMapComp);
      // }
      // this.classBasedOnFloodConditionOfPointType = await this.getMarkerColours(params); // for coloring reservoir and rivergauge points based on flood condition
      this.addSrcWiseGEOJSONLayers(layerList, gisMapComp, params);
      this.addSrcWiseWMSLayers(layerList, gisMapComp, params);
      this.addSrcWiseVECTORLayers(layerList, gisMapComp, params);
      // this.getCheckforIMDheatmap(); // Not required in Odisha
      this.formatForecastHeatMapLayers(gisMapComp); // heatmap animation layer         
      gisMapComp.otherOptions.legend = AlertMapConstants.floodforecastRiver;
      this.addLegend(gisMapComp,params);
      // if(isEmptyObject(this.miTanksMandalData)) {
        this.miTanksMandalData = await this.getMiTanksMandalData(params,gisMapComp);
      // }
      // else{
      //   document.getElementsByClassName('leaflet-legend-close')[0].dispatchEvent(new Event('click'));
      // }
    }
    if (!params.pointClick) {
      gisMapComp.map.closePopup();
      this.removeSelfCatchmentLayers(gisMapComp.map);
      this.removeGEOJSONLayers(gisMapComp);
    }

    gisMapComp.spinner = false;
  }


  addLegend(gisMapComp,params) {
    gisMapComp.legendList = {};
    for (const key in AlertMapConstants.floodforecastRiver) {
      gisMapComp.legendList[key] = AlertMapConstants.floodforecastRiver[key];
    }
    gisMapComp.manageLegend();
  }

getPostDataForAlertsData(params){
  let timeStamp = this.dataService.getTimestamps();
  let currentTimestamp = this.dataService.getNowcastTime();
  let forecastTs = this.dataService.getForecastTimestamps()
  let postData : any = {
    weatherDataType : params['alertType'],
    parentEntityUUID : 'cdf94322-30bf-456b-b0c6-b4038caebd6a',//LOCATION_UUID.ANDHRAPRADESH['ADMIN'].UUID,
    parentEntityType : "STATE",
    actualSource : "APSDPS",
    forecastSource : params['source'],
    version: "V2",
    nowcastSource : "RADAR_CTT_EUMETSAT_RF_ALERT",
  }
  // if(params['alertType'] == 'ALL'){
  //   return postData;
  // }else if(params['alertType'] == 'ACTUAL_DAILY'){
  //   postData["endTs"] = timeStamp['endTs'];
  //   postData["startTs"] = timeStamp['startTs'];
  //   return postData;
  // }else if(params['alertType'] == 'ACTUAL_HOURLY'){
  //   postData["endTs"] = currentTimestamp['endTs'];
  //   postData["startTs"] = currentTimestamp['startTs'];
  //   return postData;
  // }else if(params['alertType'] == 'NOWCAST'){
  //   return postData;
  // }else if(params['alertType'] == 'FORECAST'){
  //   postData["endTs"] = forecastTs['forecastEndTs'];
  //   postData["startTs"] = forecastTs['forecastStartTs'];
  //   return postData;
  // }
  return postData;

}

  async getMetaData(params){
    console.log('params ::',params);
    let rgPostData : any  = {
      "pUuid": "6f86292b-dd9a-4987-bb8f-c3940263b349",
      "lType": "RIVER_GAUGE",
      "timePeriod": "LASTKNOWN",
      "timestep": "HOURLY",
      "src": "ALL"
    };
    let alertsPostData : any = this.getPostDataForAlertsData(params);
    let postData = this.dataService.getPostDataTanksCount(params);
    let rgResMetaData = new Promise((resolve, reject) => {
    forkJoin(this.dataService.getAllRivergaugeMetaData(rgPostData),this.dataService.getAllReservoirMetaData(),this.dataService.getAllMarkersColourInfo(alertsPostData),this.dataService.post(VisibilityMapConstants.API_MAPPING.MITANK_COUNT, postData)).subscribe( async (response : any)=>{
      console.log('response :::',response)
      let rgResponse : any = await response[0];
      let resResponse : any = await response[1].locationTypeLocationList[0].locationList;
      let rgData : any = {};
      let resData : any = {};
      let alertsData : any = {};
      let alertresponse : any = await response[2];
      this.miTanksData = this.preProcessData(await response[3])
     
      alertsData = Object.keys(alertresponse).reduce((acc, locType) => {
        const locTypeData = alertresponse[locType];
        Object.keys(locTypeData).forEach((uuid) => {
          const alertData = locTypeData[uuid] && locTypeData[uuid].data && locTypeData[uuid].data.alertData ? locTypeData[uuid].data.alertData :{} ;  // Adjusted to reflect the new structure
          const firstAlertKey = Object.keys(alertData)[0]; // Get the first available alert key (e.g., "3HR")
          
          if (firstAlertKey) {
            const warningKey = Object.keys(alertData[firstAlertKey])[0]; // Get the first key inside it (e.g., "NORMAL", "CRITICAL")
            acc[uuid] = warningKey ? warningKey : null;
          }
        });
        return acc;
      }, {});
      
    this.alertsColorData =  alertsData;
    console.log('alertsData :::',alertsData);
      Object.keys(rgResponse).forEach((guage : any) => {
        rgData[guage] = rgResponse[guage][0];   
      });
      resResponse.forEach((reservoir : any)=>{
        let UUID : any = reservoir['locationData']['locationUuid'];
        resData[UUID] = reservoir;
      })
      console.log("resData :::",resData,'\n GaugeData :::',rgData);
      this.reservoirData = resData;
      this.rivergaugeData = rgData;
      resolve(response);
    },(error : any)=>{
      console.log("error ::",error);
    })
  })
  await Promise.all([rgResMetaData]).then(async (payloads) => {
    let payloadData : any = await payloads[0];
  });
  }

  riverNetworkLayer(feature,layerOptions) {
    let layerName : any = layerOptions.displayName.split(' ');
    let layerDate : any = layerName[layerName.length-1];
    let that = this;    
    let streamOrder: any = feature.properties.grid_code;
    let style = {
      weight:streamOrderWidth(streamOrder),
      color: getColor(feature.properties,layerDate,that),
      fillOpacity: 0.8,
    };
    function streamOrderWidth(streamOrder: any) {
      if (streamOrder == 1 || streamOrder == 2) {
        return 1;
      } else if (streamOrder == 3) {
        return 2;
      } else if (streamOrder == 4 || streamOrder == 5) {
        return 3;
      } else {
        return 1;
      }
    }

    function getColor(downPoint,date,that) {   
      let value =null;
      Object.keys(that.riverNetworkLayerStyling).forEach(key => {        
        if (downPoint.downstre_1) {
          if(key ==  downPoint.downstre_1){
            value = (that.riverNetworkLayerStyling[key] && that.riverNetworkLayerStyling[key][date] && that.riverNetworkLayerStyling[key][date]['inflowvalue']) ? that.riverNetworkLayerStyling[key][date]['inflowvalue'] : null;
          }
        }
      })
      if (value == undefined || value == null) {
        return "#b6d1ff";

      }
      if (value >= 0 && value <= 10)
        return "#b6d1ff";
      else if (value > 10 && value <= 75)
        return " #7dacfb";
      else if (value > 75 && value <= 150)
        return "#4e8ffd";
      else if (value > 150 && value <= 250)
        return "#1560e0";
      else if (value > 250 && value <= 750)
        return "#003288";
      else if (value > 750 && value <= 1500)
        return "#ffa198";
      else if (value > 1500 && value <= 3000)
        return "#fb7276";
      else if (value > 3000 && value <= 15000)
        return "#fa050c";
      else if (value > 15000 && value <= 28000)
        return "#bb0005";
      else if (value > 28000)
        return "#7e0000";
      else
        return "#b6d1ff";
    }
    return style;
  }

  reservoirRiverGaugePointLayer(feature, mapObject: L.Map, params, gisMapComp,layerType?:any) {
    // gisMapComp.spinner = true;
    let latLng: [number, number];
    latLng = [feature.geometry.coordinates[1], feature.geometry.coordinates[0]];
    let concentricCircleLayer = new L.LayerGroup();
    let marker = undefined;
    // let valuesList = Object.values(this.metaData);
    let selectedPointMetaData = feature.properties;
    // valuesList.find((eachPointDataObj:any) => {
    //   if(eachPointDataObj.uuid == feature.properties['uuid']){
    //     return eachPointDataObj;
    //   }  
    // })
    let pointType : any = (feature.properties.point_type == 'River Gauge' || feature.properties.point_type == 'RIVERGAUGE'||feature.properties.point_type == 'RIVERAGAUGE' || feature.properties.point_type == 'CANAL' || feature.properties.point_type == 'OS_CANAL') ? 'RIVER_GAUGE' : 'RESERVOIR';
    let alertType : any = this.alertsColorData[feature.properties['uuids_new']] ? this.alertsColorData[feature.properties['uuids_new']] : 'no_data';
    if (selectedPointMetaData != undefined && selectedPointMetaData['uuids_new'] == feature.properties['uuids_new']) {
      let className : any  =( selectedPointMetaData['point_type'] == "RESERVOIR" || selectedPointMetaData['point_type'] == "OS_RESERVOIR" ) ? 'reservoir' : ( selectedPointMetaData['point_type'] == "CANAL" || selectedPointMetaData['point_type'] == "OS_CANAL" ) ? "river_gauges" : ''
      const pointIcon = L.divIcon({
        html :`<div class="${className+" "+alertType}">
        <span class='alert-icon'><img src=${'../assets/imgs/alert-icons/'+className+'_'+(alertType).toLowerCase()+'.svg'}></span>
        </div>`,
        
        // className: "alert-icon",//this.classBasedOnFloodConditionOfPointType[feature.properties.uuid],
        iconSize: [10, 10],
        iconAnchor: [4, 4],
        popupAnchor: [-5, -5],
      });
      if(selectedPointMetaData['point_type'] == "RESERVOIR" || selectedPointMetaData['point_type'] == "OS_RESERVOIR" || selectedPointMetaData['point_type'] == "CANAL" || selectedPointMetaData['point_type'] == "OS_CANAL" || (selectedPointMetaData['point_type'] == "RIVERGAUGE")){
        marker = L.marker(latLng, { icon: pointIcon, pane: 'marker' });

      }
      let index : any =this.majorReservoirs.indexOf(feature.properties['uuids_new']);
      // console.log('alertType :::',alertType,'\n layerType :::',layerType,"\npointType ::::",pointType);
      if(!isNullOrUndefined(marker) && index == -1){
        if((alertType != null && alertType != undefined && alertType.toLowerCase() == layerType) ){
          concentricCircleLayer.addLayer(marker);
        }
      }
    }

    var string_text ="";
    
    if(pointType == 'RIVER_GAUGE'){
      let gaugeData : any = this.rivergaugeData[feature.properties.uuids_new] ? this.rivergaugeData[feature.properties.uuids_new] : undefined;
      string_text = this.setHtmlContentForRivergauge(gaugeData,feature.properties,params)
    }else if(pointType == 'RESERVOIR'){
      let resData : any = this.reservoirData[feature.properties.uuids_new] ? this.reservoirData[feature.properties.uuids_new] : undefined;
      string_text = this.setHtmlContentForReservoir(resData,feature.properties)
    }

    if (marker) {
      // marker.bindPopup("loading...", popupOptionsHover);
      marker.on({
        mouseover: (e) => {
        },
        mouseout: (e) => {
        },
        click: (e) => {
          console.log("entered :::",e,feature);
          function makeDraggable(popup){
            var draggable = new L.Draggable(popup._container, popup._wrapper);
            draggable.enable();
          }
          gisMapComp.spinner = true;
          document.getElementsByClassName('leaflet-legend-close')[0].dispatchEvent(new Event('click'));
          const popup = R.responsivePopup({ className :'alert-popup', hasTip: false, autoPan: false, pane: 'popUpGeoJson', offset: [1, 2], minWidth: 360, maxWidth: 450, closeButton: true })
            .setLatLng(e["latlng"])
            .setContent(string_text)
            .openOn(mapObject);
            makeDraggable(popup);
            const seemoreElement : any = document.querySelector(`.seemore${feature.properties['uuids_new']}`);
            // seemoreElement.addEventListener('click', () => {
            //   this.navigateToNowcast({
            //     lat : feature.properties['latitude'],
            //     long : feature.properties['longitude'],
            //     pointClicked : true
            //   })
            // });
          gisMapComp.map.setView(e["latlng"],14);
          params['pointType'] = (feature.properties.point_type == 'River Gauge' || feature.properties.point_type == 'RIVERGAUGE'||feature.properties.point_type == 'RIVERAGUGE' || feature.properties.point_type == 'CANAL' || feature.properties.point_type == 'OS_CANAL') ? 'RIVER_GAUGE' : (feature.properties.point_type == 'RESERVOIR' || feature.properties.point_type == 'OS_RESERVOIR') ? 'RESERVOIR': '';
          params['location'] = feature.properties.point_na_1;
          params['lUUID'] = feature.properties.uuid_point;
          params['pointClick'] = true;
          params['featureObj'] = feature;
          params['locName'] = feature.properties.point_na_1;
          params['pUUID'] = feature.properties['uuids_new'];
          params['pType'] = params['pointType'];
          params['cType'] = params['pointType'];
          params['actionType'] = 'sensorClick';
          gisMapComp.dataTabToggleVal = true;

          this.gisUtils.setSelectedParams(params);
          this.addSelfCatchmentBoundary(mapObject, gisMapComp,params['pointType'] ,feature.properties);
        }
      });
    }
    return concentricCircleLayer;

  }

  majorReservoirPointLayer(feature, mapObject: L.Map, params, gisMapComp,layerType?: any) {
    // gisMapComp.spinner = true;
    let latLng: [number, number];
    latLng = [feature.geometry.coordinates[1], feature.geometry.coordinates[0]];
    let concentricCircleLayer = new L.LayerGroup();
    let marker = undefined;
    // let valuesList = Object.values(this.metaData);
    let selectedPointMetaData = feature.properties;
    // valuesList.find((eachPointDataObj:any) => {
    //   if(eachPointDataObj.uuid == feature.properties['uuid']){
    //     return eachPointDataObj;
    //   }  
    // })
    let pointType : any = (feature.properties.point_type == 'River Gauge' || feature.properties.point_type == 'RIVERGAUGE'||feature.properties.point_type == 'RIVERAGAUGE' || feature.properties.point_type == 'CANAL' || feature.properties.point_type == 'OS_CANAL') ? 'RIVER_GAUGE' : 'RESERVOIR';
    let alertType : any = this.alertsColorData[feature.properties['uuids_new']] ? this.alertsColorData[feature.properties['uuids_new']] : 'no_data';
    // console.log("alertType :::",alertType,pointType);
    if (selectedPointMetaData != undefined && selectedPointMetaData['uuids_new'] == feature.properties['uuids_new']) {
      let className : any  =( selectedPointMetaData['point_type'] == "RESERVOIR" || selectedPointMetaData['point_type'] == "OS_RESERVOIR" ) ? 'reservoir' : ( selectedPointMetaData['point_type'] == "CANAL" || selectedPointMetaData['point_type'] == "OS_CANAL" ) ? "river_gauges" : ''
      const pointIcon = L.divIcon({
        html :`<div class="${className+" "+alertType}">
        <span class='alert-icon'><img src=${'../assets/imgs/alert-icons/'+className+'_'+(alertType).toLowerCase()+'.svg'}></span>
        </div>`,
        
        // className: "alert-icon",//this.classBasedOnFloodConditionOfPointType[feature.properties.uuid],
        iconSize: [10, 10],
        iconAnchor: [4, 4],
        popupAnchor: [-5, -5],
      });
      if(selectedPointMetaData['point_type'] == "RESERVOIR" || selectedPointMetaData['point_type'] == "OS_RESERVOIR" || selectedPointMetaData['point_type'] == "CANAL" || selectedPointMetaData['point_type'] == "OS_CANAL" || (selectedPointMetaData['point_type'] == "RIVERGAUGE")){
        marker = L.marker(latLng, { icon: pointIcon, pane: 'marker' });

      }
      let index : any =this.majorReservoirs.indexOf(feature.properties['uuids_new']);
      if(!isNullOrUndefined(marker) && index!=-1 && alertType.toLowerCase() == layerType){
        concentricCircleLayer.addLayer(marker);
      }
    }

    var string_text ="";
    
    if(pointType == 'RIVER_GAUGE'){
      let gaugeData : any = this.rivergaugeData[feature.properties.uuids_new] ? this.rivergaugeData[feature.properties.uuids_new] : undefined;
      string_text = this.setHtmlContentForRivergauge(gaugeData,feature.properties,params)
    }else if(pointType == 'RESERVOIR'){
      let resData : any = this.reservoirData[feature.properties.uuids_new] ? this.reservoirData[feature.properties.uuids_new] : undefined;
      string_text = this.setHtmlContentForReservoir(resData,feature.properties)
    }

    if (marker) {
      // marker.bindPopup("loading...", popupOptionsHover);
      marker.on({
        mouseover: (e) => {
        },
        mouseout: (e) => {
        },
        click: (e) => {
          console.log("entered :::",e,feature);
          function makeDraggable(popup){
            var draggable = new L.Draggable(popup._container, popup._wrapper);
            draggable.enable();
          }
          gisMapComp.spinner = true;
          document.getElementsByClassName('leaflet-legend-close')[0].dispatchEvent(new Event('click'));
          const popup = R.responsivePopup({ className :'alert-popup', hasTip: false, autoPan: false, pane: 'popUpGeoJson', 
            offset: [1, 2], minWidth: 360, maxWidth: 450, closeButton: true }).setLatLng(e["latlng"]).setContent(string_text);
            marker.bindPopup(popup).openPopup();
            makeDraggable(popup);
            // const seemoreElement : any = document.querySelector(`.seemore${feature.properties['uuids_new']}`);
            // seemoreElement.addEventListener('click', () => {
            //   this.navigateToNowcast({
            //     lat : feature.properties['latitude'],
            //     long : feature.properties['longitude'],
            //     pointClicked : true
            //   })
            // });
          gisMapComp.map.setView(e["latlng"],14);
          gisMapComp.dataTabToggleVal = true;
          params['pointType'] = (feature.properties.point_type == 'River Gauge' || feature.properties.point_type == 'RIVERGAUGE'||feature.properties.point_type == 'RIVERAGUGE' || feature.properties.point_type == 'CANAL' || feature.properties.point_type == 'OS_CANAL') ? 'RIVER_GAUGE' : (feature.properties.point_type == 'RESERVOIR' || feature.properties.point_type == 'OS_RESERVOIR') ? 'RESERVOIR': '';
          params['location'] = feature.properties.point_name;
          params['lUUID'] = feature.properties.uuid_point;
          params['pointClick'] = true;
          params['featureObj'] = feature;
          params['locName'] = feature.properties.point_name;
          params['pUUID'] = feature.properties['uuids_new'];
          params['pType'] = params['pointType'];
          params['cType'] = params['pointType'];
          params['actionType'] = 'sensorClick';

          this.gisUtils.setSelectedParams(params);
          this.addSelfCatchmentBoundary(mapObject, gisMapComp,params['pointType'] ,feature.properties);
        }
      });
    }
    return concentricCircleLayer;

  }

  mitanksPointLayer(feature, mapObject: L.Map, params, gisMapComp,layerType?:any) {
    // gisMapComp.spinner = true;    
    let latLng: [number, number];
    latLng = [feature.geometry.coordinates[1], feature.geometry.coordinates[0]];
    let concentricCircleLayer = new L.LayerGroup();
    let marker = undefined;
    // let valuesList = Object.values(this.metaData);
    let selectedPointMetaData = feature.properties;
    // valuesList.find((eachPointDataObj:any) => {
    //   if(eachPointDataObj.uuid == feature.properties['uuid']){
    //     return eachPointDataObj;
    //   }  
    // })
    let pointType : any = 'MITANK'
    let alertType : any = this.alertsColorData[feature.properties['uuid']] ? this.alertsColorData[feature.properties['uuid']] : 'normal';
    if (selectedPointMetaData != undefined && selectedPointMetaData['uuid'] == feature.properties['uuid']) {
      let className : any  = 'mi_tanks'
      const pointIcon = L.divIcon({
        html :`<div class="${className+" "+alertType}">
        <span class='alert-icon'><img src=${'../assets/imgs/alert-icons/'+className+'_'+(alertType).toLowerCase()+'.svg'}></span>
        </div>`,
        
        // className: "alert-icon",//this.classBasedOnFloodConditionOfPointType[feature.properties.uuid],
        iconSize: [10, 10],
        iconAnchor: [4, 4],
        popupAnchor: [-5, -5],
      });
      // if(selectedPointMetaData['point_type'] == "RESERVOIR" || selectedPointMetaData['point_type'] == "OS_RESERVOIR" || selectedPointMetaData['point_type'] == "CANAL" || selectedPointMetaData['point_type'] == "OS_CANAL" || (selectedPointMetaData['point_type'] == "RIVERGAUGE")){
        marker = L.marker(latLng, { icon: pointIcon, pane: 'marker' });

      // }
      // let index : any =this.majorReservoirs.indexOf(feature.properties['uuid']);
      // console.log('mitanks :::',alertType,'\n layerType :::',layerType,"\npointType ::::",pointType);
      if(!isNullOrUndefined(marker)){
        if((alertType != null && alertType != undefined && alertType.toLowerCase() == layerType) ){          
          concentricCircleLayer.addLayer(marker);
        }
      }
    }

    var string_text ="";
    string_text = this.setHtmlContentForMiTankPoints(feature.properties)

    if (marker) {
      // marker.bindPopup("loading...", popupOptionsHover);
      marker.on({
        mouseover: (e) => {
        },
        mouseout: (e) => {
        },
        click: (e) => {
          console.log("entered :::",e,feature);
          function makeDraggable(popup){
            var draggable = new L.Draggable(popup._container, popup._wrapper);
            draggable.enable();
          }
          gisMapComp.spinner = true;
          document.getElementsByClassName('leaflet-legend-close')[0].dispatchEvent(new Event('click'));
          const popup = R.responsivePopup({ className :'alert-popup', hasTip: false, autoPan: false, pane: 'popUpGeoJson', offset: [1, 2], minWidth: 360, maxWidth: 450, closeButton: true })
            .setLatLng(e["latlng"])
            .setContent(string_text)
            .openOn(mapObject);
            makeDraggable(popup);
            const seemoreElement : any = document.querySelector(`.seemore${feature.properties['uuid']}`);
            // seemoreElement.addEventListener('click', () => {
            //   this.navigateToNowcast({
            //     lat : feature.properties['latitude'],
            //     long : feature.properties['longitude'],
            //     pointClicked : true
            //   })
            // });
          gisMapComp.map.setView(e["latlng"],14);
          params['pointType'] = 'MITANK';
          params['location'] = feature.properties.tank_nam_1;
          params['lUUID'] = feature.properties.uuid;
          params['pointClick'] = true;
          params['featureObj'] = feature;
          params['locName'] = feature.properties.tank_nam_1;
          params['pUUID'] = feature.properties['uuid'];
          params['pType'] = params['pointType'];
          params['cType'] = params['pointType'];
          params['actionType'] = 'sensorClick';
          gisMapComp.dataTabToggleVal = true;

          this.gisUtils.setSelectedParams(params);
          this.addSelfCatchmentBoundary(mapObject, gisMapComp,params['pointType'] ,feature.properties);
        }
      });
    }
    return concentricCircleLayer;

  }

  alertRiverGaugePointLayer(feature, mapObject: L.Map, params, gisMapComp,layerType?:any) {
    // gisMapComp.spinner = true;
    let latLng: [number, number];
    latLng = [feature.geometry.coordinates[1], feature.geometry.coordinates[0]];
    let concentricCircleLayer = new L.LayerGroup();
    let marker = undefined;
    // let valuesList = Object.values(this.metaData);
    let selectedPointMetaData = feature.properties;
    // valuesList.find((eachPointDataObj:any) => {
    //   if(eachPointDataObj.uuid == feature.properties['uuid']){
    //     return eachPointDataObj;
    //   }  
    // })
    let pointType : any = (feature.properties.point_type == 'River Gauge' || feature.properties.point_type == 'RIVERGAUGE'||feature.properties.point_type == 'RIVERAGAUGE' || feature.properties.point_type == 'CANAL' || feature.properties.point_type == 'OS_CANAL') ? 'RIVER_GAUGE' : 'RESERVOIR';
    let alertType : any = this.alertsColorData[feature.properties['uuids_new']] ? this.alertsColorData[feature.properties['uuids_new']] : 'no_data';
    if (selectedPointMetaData != undefined && selectedPointMetaData['uuids_new'] == feature.properties['uuids_new']) {
      let className : any  =( selectedPointMetaData['point_type'] == "RESERVOIR" || selectedPointMetaData['point_type'] == "OS_RESERVOIR" ) ? 'reservoir' : ( selectedPointMetaData['point_type'] == "CANAL" || selectedPointMetaData['point_type'] == "OS_CANAL" ) ? "river_gauges" : ''
      const pointIcon = L.divIcon({
        html :`<div class="${className+" "+alertType}">
        <span class='alert-icon'><img src=${'../assets/imgs/alert-icons/'+className+'_'+(alertType == 'NORMAL' ? 'no_data' : alertType).toLowerCase()+'.svg'}></span>
        </div>`,
        
        // className: "alert-icon",//this.classBasedOnFloodConditionOfPointType[feature.properties.uuid],
        iconSize: [10, 10],
        iconAnchor: [4, 4],
        popupAnchor: [-5, -5],
      });
      if(selectedPointMetaData['point_type'] == "RESERVOIR" || selectedPointMetaData['point_type'] == "OS_RESERVOIR" || selectedPointMetaData['point_type'] == "CANAL" || selectedPointMetaData['point_type'] == "OS_CANAL" || (selectedPointMetaData['point_type'] == "RIVERGAUGE")){
        marker = L.marker(latLng, { icon: pointIcon, pane: 'marker' });

      }
      // console.log('alertType :::',alertType,'\n layerType :::',layerType,"\npointType ::::",pointType);
      if(!isNullOrUndefined(marker) && alertType != null && alertType != undefined && alertType.toLowerCase() == layerType){
        concentricCircleLayer.addLayer(marker);
      }
    }

    var string_text ="";
    
    if(pointType == 'RIVER_GAUGE'){
      let gaugeData : any = this.rivergaugeData[feature.properties.uuids_new] ? this.rivergaugeData[feature.properties.uuids_new] : undefined;
      string_text = this.setHtmlContentForRivergauge(gaugeData,feature.properties,params)
    }else if(pointType == 'RESERVOIR'){
      let resData : any = this.reservoirData[feature.properties.uuids_new] ? this.reservoirData[feature.properties.uuids_new] : undefined;
      string_text = this.setHtmlContentForReservoir(resData,feature.properties)
    }

    if (marker) {
      // marker.bindPopup("loading...", popupOptionsHover);
      marker.on({
        mouseover: (e) => {
        },
        mouseout: (e) => {
        },
        click: (e) => {
          console.log("entered :::",e,feature);
          function makeDraggable(popup){
            var draggable = new L.Draggable(popup._container, popup._wrapper);
            draggable.enable();
          }
          gisMapComp.spinner = true;
          document.getElementsByClassName('leaflet-legend-close')[0].dispatchEvent(new Event('click'));
          const popup = R.responsivePopup({ className :'alert-popup', hasTip: false, autoPan: false, pane: 'popUpGeoJson', offset: [1, 2], minWidth: 360, maxWidth: 450, closeButton: true })
            .setLatLng(e["latlng"])
            .setContent(string_text)
            .openOn(mapObject);
            makeDraggable(popup);
            const seemoreElement : any = document.querySelector(`.seemore${feature.properties['uuids_new']}`);
            // seemoreElement.addEventListener('click', () => {
            //  this.navigateToNowcast({
            //     lat : feature.properties['latitude'],
            //     long : feature.properties['longitude'],
            //     pointClicked : true
            //   })
            // });
          gisMapComp.map.setView(e["latlng"],14);
          gisMapComp.dataTabToggleVal = true;
          params['pointType'] = (feature.properties.point_type == 'River Gauge' || feature.properties.point_type == 'RIVERGAUGE'||feature.properties.point_type == 'RIVERAGUGE' || feature.properties.point_type == 'CANAL' || feature.properties.point_type == 'OS_CANAL') ? 'RIVER_GAUGE' : (feature.properties.point_type == 'RESERVOIR' || feature.properties.point_type == 'OS_RESERVOIR') ? 'RESERVOIR': '';
          params['location'] = feature.properties.point_name;
          params['lUUID'] = feature.properties.uuid_point;
          params['pointClick'] = true;
          params['featureObj'] = feature;
          params['locName'] = feature.properties.point_name;
          params['pUUID'] = feature.properties['uuids_new'];
          params['pType'] = params['pointType'];
          params['cType'] = params['pointType'];
          params['actionType'] = 'sensorClick';

          this.gisUtils.setSelectedParams(params);
          this.addSelfCatchmentBoundary(mapObject, gisMapComp,params['pointType'] ,feature.properties);
        }
      });
    }
    return concentricCircleLayer;

  }

  alertMitankPointLayer(feature, mapObject: L.Map, params, gisMapComp,layerType?:any) {
    // gisMapComp.spinner = true;
    let latLng: [number, number];
    latLng = [feature.geometry.coordinates[1], feature.geometry.coordinates[0]];
    let concentricCircleLayer = new L.LayerGroup();
    let marker = undefined;
    // let valuesList = Object.values(this.metaData);
    let selectedPointMetaData = feature.properties;
    // valuesList.find((eachPointDataObj:any) => {
    //   if(eachPointDataObj.uuid == feature.properties['uuid']){
    //     return eachPointDataObj;
    //   }  
    // })
    let pointType : any = 'MITANK';
    let alertType : any = this.alertsColorData[feature.properties['uuid']] ? this.alertsColorData[feature.properties['uuid']] : 'no_data';
    if (selectedPointMetaData != undefined && selectedPointMetaData['uuid'] == feature.properties['uuid']) {
      let className : any  = 'mi_tanks'
      const pointIcon = L.divIcon({
        html :`<div class="${className+" "+alertType}">
        <span class='alert-icon'><img src=${'../assets/imgs/alert-icons/'+className+'_'+(alertType == 'NORMAL' ? 'no_data' : alertType).toLowerCase()+'.svg'}></span>
        </div>`,
        
        // className: "alert-icon",//this.classBasedOnFloodConditionOfPointType[feature.properties.uuid],
        iconSize: [10, 10],
        iconAnchor: [4, 4],
        popupAnchor: [-5, -5],
      });
      // if(selectedPointMetaData['point_type'] == "RESERVOIR" || selectedPointMetaData['point_type'] == "OS_RESERVOIR" || selectedPointMetaData['point_type'] == "CANAL" || selectedPointMetaData['point_type'] == "OS_CANAL" || (selectedPointMetaData['point_type'] == "RIVERGAUGE")){
        marker = L.marker(latLng, { icon: pointIcon, pane: 'marker' });

      // }
      // console.log('alertType :::',alertType,'\n layerType :::',layerType,"\npointType ::::",pointType);
      if(!isNullOrUndefined(marker) && alertType != null && alertType != undefined && alertType.toLowerCase() == layerType){
        concentricCircleLayer.addLayer(marker);
      }
    }

    var string_text ="";
    string_text = this.setHtmlContentForMiTankPoints(feature.properties)
    if (marker) {
      // marker.bindPopup("loading...", popupOptionsHover);
      marker.on({
        mouseover: (e) => {
        },
        mouseout: (e) => {
        },
        click: (e) => {
          console.log("entered :::",e,feature);
          function makeDraggable(popup){
            var draggable = new L.Draggable(popup._container, popup._wrapper);
            draggable.enable();
          }
          gisMapComp.spinner = true;
          document.getElementsByClassName('leaflet-legend-close')[0].dispatchEvent(new Event('click'));
          const popup = R.responsivePopup({ className :'alert-popup', hasTip: false, autoPan: false, pane: 'popUpGeoJson', offset: [1, 2], minWidth: 360, maxWidth: 450, closeButton: true })
            .setLatLng(e["latlng"])
            .setContent(string_text)
            .openOn(mapObject);
            makeDraggable(popup);
            const seemoreElement : any = document.querySelector(`.seemore${feature.properties['uuid']}`);
            // seemoreElement.addEventListener('click', () => {
            //  this.navigateToNowcast({
            //     lat : feature.properties['latitude'],
            //     long : feature.properties['longitude'],
            //     pointClicked : true
            //   })
            // });
          gisMapComp.map.setView(e["latlng"],14);
          gisMapComp.dataTabToggleVal = true;
          params['pointType'] = 'MITANK';
          params['location'] = feature.properties.tank_nam_1;
          params['lUUID'] = feature.properties.uuid;
          params['pointClick'] = true;
          params['featureObj'] = feature;
          params['locName'] = feature.properties.tank_nam_1;
          params['pUUID'] = feature.properties['uuid'];
          params['pType'] = params['pointType'];
          params['cType'] = params['pointType'];
          params['actionType'] = 'sensorClick';

          this.gisUtils.setSelectedParams(params);
          this.addSelfCatchmentBoundary(mapObject, gisMapComp,params['pointType'] ,feature.properties);
        }
      });
    }
    return concentricCircleLayer;

  }

  async getRiverNetworkData(params: any) {
    let networkData = {}
      let postData = {
        currDayTimestep : this.getCurrentDayInflowTimestamp(),
        basinuuid : params.basinUUID
      }
      var riverFlowdata = new Promise((resolve, reject) => {
        this.dataService.getRiverFlowDataToStyle(postData).subscribe((data: any) => {
          resolve(data);
        }, error => {
          resolve({})
        })
      });
      await Promise.all([riverFlowdata]).then(async (payloads) => {
        networkData = await payloads[0];
      });
      let DataObj = {};
      Object.keys(networkData).forEach(basin=>{
        Object.keys(networkData[basin]).forEach(key=>{
          DataObj[key] = {};
          Object.keys(networkData[basin][key]).forEach(key2=>{
              if(params.src == "IMD Merged"){  
                DataObj[key]['inflowvalue'] = (networkData[basin][key][key2]['-7']);
              }
              if(params.src =="ECMWF"){
                DataObj[key]['inflowvalue'] = (networkData[basin][key][key2]['-8']);
              }
          });  
        }) 
      })
      this.riverNetworkLayerStyling  = DataObj;      
  }

  getCurrentDayInflowTimestamp(){
    let date = new Date();
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    let time = date.getTime().toString();
    let timestepvalue = Number(time.substring(0,10) + '000')
    return timestepvalue;
  }


  addSelfCatchmentBoundary(mapObj: any, gisMapComp: any, componentType : any, properties?: any) {
    let cqlfilter : any = componentType == 'MITANK' ? 'entity_uui' : (componentType == 'RESERVOIR' || componentType == 'RIVER_GAUGE') ?  'uuids_new' :'ulb_uuid';
    console.log('prperties :::',properties);
    let params: any = gisMapComp.params;
    let url: any;
    this.removeSelfCatchmentLayers(mapObj);
    if (properties) {
      url = environment.url.NEW_GEOSERVER_URL + AlertMapConstants.Geoserver_Workspace + AlertMapConstants.GeoJSON_Pre_url + AlertMapConstants.SELF_CATCHMENT_LAYER_NAME[componentType] + AlertMapConstants.geoJson_post_url + "&CQL_FILTER="+cqlfilter+"='" + gisMapComp.params.pUUID + "'";
    } else {
      url = environment.url.NEW_GEOSERVER_URL + AlertMapConstants.Geoserver_Workspace + AlertMapConstants.GeoJSON_Pre_url + AlertMapConstants.SELF_CATCHMENT_LAYER_NAME[componentType] + AlertMapConstants.geoJson_post_url + "&CQL_FILTER="+cqlfilter+"='" + gisMapComp.params.pUUID + "'";
    }
    this.dataService.geoJsonCall(url).subscribe((geoData: any) => {
      let geoLayer = L.geoJSON(geoData, {
        pane: 'elev',
        style: {
          weight: 1,
          opacity: 1.0,
          color: '#1f81fe',
          fillColor: '#1f81fe',
          fillOpacity: 0.4,
        }
      });
      this.catchmentLayerList.push(geoLayer);
      // This params update is to get the catchment uuid for the layer and is used as a parameter for get api to show Rainfall forecast chart in infobox
      // if (properties) {
      //   params['catchmentUUID'] = geoData.features.length > 0 ? geoData.features[0].properties.sefca_uuid : undefined;
      //   // I can use setselectedparams but this is hindering me to fit the self catchment polygon to bbox 
      //   this.gisUtils.setPointLayerParams(params);
      // }
      if (geoData.features.length > 0) {
        mapObj.addLayer(geoLayer);
        gisMapComp.showThrobber = false;
      } else {
        gisMapComp.showThrobber = false;
        console.log('default:::Features Not Available');
      }
    })
    gisMapComp.spinner = false;
  }
  removeSelfCatchmentLayers(mapObj: any) {
    if (this.catchmentLayerList.length > 0) {
      if (!isNullOrUndefined(this.catchmentLayerList)) {
        this.catchmentLayerList.forEach((point) => {
          if (!isNullOrUndefined(point)) {
            mapObj.removeLayer(point);
          }
        });
      }
    }
  }

  getRadius(val) {
    val = Number(val);
    let OuterRadius = this.minRadius;
    if (val != null) {
      OuterRadius = this.minRadius + (val / this.maxCapacity) * (this.maxRadius - this.minRadius);
    }
    return OuterRadius;
  }

  addRivergaugeMarkerLayer(feature, mapObject: L.Map, params, gisMapComp, layerType? : any) {
    let latlng: [number, number];
    if (gisMapComp.params.src == feature.properties.source) {
      latlng = [feature.geometry.coordinates[1], feature.geometry.coordinates[0]];
    }
    if (gisMapComp.params.src == 'STATE_AND_CENTRAL_STATIONS') {
      latlng = [feature.geometry.coordinates[1], feature.geometry.coordinates[0]];
    }
  
    let currentZoom = mapObject.getZoom();
    const popup = R.responsivePopup({
      hasTip: true,
      autoPan: false,
      minWidth: 250,
      pane: 'popUpGeoJson',
      maxWidth: 300,
      closeButton: false,
      className : 'alert-popup'
    });
  
    let concentricCircleLayer = new L.LayerGroup();
    let formattedRivergaugeData = this.rivergaugeData
      ? this.rivergaugeData[feature.properties.rivergauge]
      : undefined;
  
    let outerRadius = this.minRadius;
    if (feature.properties.capacity) {
      outerRadius = this.getRadius(feature.properties.capacity);
    }
  
    let innerRadius = this.minRadius;
  
    // Create Custom DivIcon for Concentric Circles
    let alertType : any = this.alertsColorData[feature.properties['ulb_uuid']] ? this.alertsColorData[feature.properties['ulb_uuid']] : 'no_data';
    // console.log('alertType :::',alertType,'\n layerType :::',layerType);
    let className : any  ="cities" ;
      const pointIcon = L.divIcon({
        html :`<div class="${className+" "+alertType}">
        <span class='alert-icon'><img src=${'../assets/imgs/alert-icons/'+className+'_'+(alertType).toLowerCase()+'.svg'}></span>
        </div>`,
        // className: className,//this.classBasedOnFloodConditionOfPointType[feature.properties.uuid],
        iconSize: [10, 10],
        iconAnchor: [4, 4],
        popupAnchor: [-5, -5],
      });
  
    if (!isNullOrUndefined(latlng)) {
      
      const outerColor = formattedRivergaugeData ? (formattedRivergaugeData['color'] ? formattedRivergaugeData['color'] :'gray') : 'gray';
      const innerColor = formattedRivergaugeData ? (formattedRivergaugeData['color'] ? formattedRivergaugeData['color'] : 'gray') : 'gray';
      // innerCircleOptions.fillColor = formattedRivergaugeData ? (formattedRivergaugeData['color'] ? formattedRivergaugeData['color'] : 'gray') : 'gray';

      // const markerIcon = createCircleIcon(
      //   this.getCircleMarkerRadius(currentZoom, innerRadius),
      //   this.getCircleMarkerRadius(currentZoom, outerRadius),
      //   innerColor,
      //   outerColor,
      // );
      

      const marker = L.marker(latlng, { icon: pointIcon , pane: 'marker'});
      if(alertType != null && alertType != undefined && alertType.toLowerCase() == layerType){
        concentricCircleLayer.addLayer(marker);
      }

      marker.on({
        mouseover: (e) => {
        },
        click: (e) => {
          // if (formattedRivergaugeData == undefined) {
          //   return;
          // }
          popup.setContent(this.setHtmlContentForCity(formattedRivergaugeData, feature.properties));
          popup.setLatLng(e['latlng']);
          marker.bindPopup(popup).openPopup();
          let data = feature.properties;
          gisMapComp.map.setView([e['latlng']['lat'],e['latlng']['lng']],LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN+4)
          params['locName'] = data['tn_name'];
          params['pUUID'] = data['ulb_uuid'];
          params['pType'] = feature && feature.id && (feature.id).includes('CITIES') ? 'CITY' : 'MITANK';
          params['cType'] = feature && feature.id && (feature.id).includes('CITIES') ? 'CITY' : 'MITANK';
          params['actionType'] = 'sensorClick';
          params['pointClick'] =true;
          params['pointType'] = feature && feature.id && (feature.id).includes('CITIES') ? 'CITY' : 'MITANK'; 
          feature.properties['lat'] = feature['geometry']['coordinates'][1];
          feature.properties['long'] = feature['geometry']['coordinates'][0];
          gisMapComp.dataTabToggleVal = true;
          this.gisUtils.setSelectedParams(params);
          let componentType : any = feature && feature.id && (feature.id).includes('CITIES') ? 'CITY' : 'MITANK'; 
          this.addSelfCatchmentBoundary(mapObject, gisMapComp,componentType, feature.properties);
          const seemoreElement : any = document.querySelector(`.seemore${feature.properties['ulb_uuid']}`);
          // seemoreElement.addEventListener('click', () => {
          //   this.navigateToNowcast({
          //     lat : feature.properties['lat'],
          //     long : feature.properties['long'],
          //     pointClicked : true
          //   })
          // });
  //    document.getElementById('closePopupBtn')?.addEventListener('click', () => {
  // gisMapComp.map.closePopup();
        }
      });

      mapObject.on({
        zoomend: () => {
          // Get the updated zoom level
          let updatedZoom = mapObject.getZoom();
      
          // Recalculate radii based on the updated zoom level
          const updatedInnerRadius = this.getCircleMarkerRadius(updatedZoom, this.minRadius);
          const updatedOuterRadius = this.getCircleMarkerRadius(updatedZoom, this.minRadius);
      
          // Update the marker's icon with the recalculated sizes
          // const updatedIcon = createCircleIcon(
          //   updatedInnerRadius,
          //   updatedOuterRadius,
          //   innerColor,
          //   outerColor
          // );
      
          // marker.setIcon(updatedIcon);
        },
      }); 
    }
  
    return concentricCircleLayer;
  }
  
  setHtmlContentForRivergauge(formattedRivergaugeData, properties,params) {
    // console.log("aggrData rg ::::",formattedRivergaugeData,properties['uuid']);
    let level,depth,flow,name,trend,basin,lat,long,river;
    if(formattedRivergaugeData != undefined){
      level = formattedRivergaugeData['l'] != undefined?this.utilsSrv.getDecimalFixedWithRespectToDigit(formattedRivergaugeData['l']): formattedRivergaugeData['waterLevel']!= undefined ? this.utilsSrv.getDecimalFixedWithRespectToDigit(formattedRivergaugeData['waterLevel']) : '-';  '-';  
      depth = formattedRivergaugeData['d'] != undefined?this.utilsSrv.getDecimalFixedWithRespectToDigit(formattedRivergaugeData['d']): formattedRivergaugeData['waterDischarge']!= undefined ? this.utilsSrv.getDecimalFixedWithRespectToDigit(formattedRivergaugeData['waterDischarge']) : '-';  '-';  
      flow= formattedRivergaugeData['flow']!= '-' ?this.utilsSrv.fixedToDecimal(formattedRivergaugeData['flow'],0):'-';   
      name = formattedRivergaugeData['name'] ? formattedRivergaugeData['name'] : formattedRivergaugeData['dex'] && formattedRivergaugeData['dex']['name']!= undefined ? formattedRivergaugeData['dex']['name'] : '-';
      trend = formattedRivergaugeData['trnd']!=null?formattedRivergaugeData['trnd']:'-';
      basin = formattedRivergaugeData['basinName'];  
      lat = formattedRivergaugeData['la']!= undefined?this.utilsSrv.getDecimalFixed(formattedRivergaugeData['la']) : (formattedRivergaugeData['dex'] && formattedRivergaugeData['dex']['latitude']!= undefined ? this.utilsSrv.getDecimalFixed(formattedRivergaugeData['dex']['latitude']) : '-');  
      long = formattedRivergaugeData['lg']!= undefined?this.utilsSrv.getDecimalFixed(formattedRivergaugeData['lg']): (formattedRivergaugeData['dex'] && formattedRivergaugeData['dex']['longitude']!= undefined ? this.utilsSrv.getDecimalFixed(formattedRivergaugeData['dex']['longitude']) : '-');  
      river = formattedRivergaugeData['river']!=null?formattedRivergaugeData['river']:'-';
    }
    else{
      level = '-'; 
      depth = '-' 
      flow= '-';  
      name = properties.hasOwnProperty('point_na_1') ? properties['point_na_1']  : '-';
      trend =  '-';  
      basin = properties.hasOwnProperty('basin') ? properties['basin'] : '-'; 
      lat = properties.hasOwnProperty('latitude') ? this.utilsSrv.getFiveDecimalFixed(properties['latitude']):' - ';  
      long = properties.hasOwnProperty('longitude') ? this.utilsSrv.getFiveDecimalFixed(properties['longitude']):' - ';
      river = '-';
    }
    var htmlString = "<html><body>";
    htmlString += '<div class="alert-poupup-table">';
    htmlString += `<div class="card-body p-0">
       <table class="table table-sm m-0 table-bordered ">`;
    htmlString += `<tbody>
       <tr>
         <th>Rivergauge Name</th>
         <td>${ name ? name : '-'}</td>
       </tr>
       <tr>
       <th> Basin </th>
            <td>${ basin ? basin : '-'}</td>
      </tr>
      <tr>
      <th> Current Level </th>
            <td>${ level ? level : '-'}</td>
      </tr>
      <tr>
      <th> Depth </th>
            <td>${ depth ? depth : '-'}</td>
      </tr>
      <tr>
      <th> River </th>
            <td>${ river ? river : '-'}</td>
      </tr>
      <tr>
      <th> Trend </th>
            <td>${ trend ? trend : '-'}</td>
      </tr>
      <tr>
      <th> Latitude </th>
            <td>${ lat ? lat : '-'}</td>
      </tr>
      <tr>
      <th> Longitude </th>
            <td>${ long ? long : '-'}</td>
      </tr>
      <tr><a class="seemore${properties['uuid']}" style="width:100%;display:block;text-align:right;text-decoration: nonerfLevel;font-size:10px">See More <i class="bi bi-chevron-right"></i></a></tr>
     </table>
   </div>
   </div>`;
    return htmlString;
  }

  navigateToNowcast(latlng : any){
    this.dataService.setPointData(latlng);
    this.router.navigate(['','nowcastweather','radar-forecast','akbm'])
  }

  setHtmlContentForReservoir(formattedRivergaugeData, properties){
    // console.log("aggrData res ::::",formattedRivergaugeData,properties['uuid'],properties);
    let capacity,level,depth,storage,name,trend,basin,lat,long,district,block;
    if(formattedRivergaugeData != undefined){
      let popUpData : any = formattedRivergaugeData['popupData']['body'];
      let geoData : any = formattedRivergaugeData['locationData']['extensions'];
      level = popUpData[1]['value'] != undefined ? popUpData[1]['value'] : '-';  
      capacity = popUpData[0]['value'] != undefined ? popUpData[0]['value'] : '-';  
      storage= popUpData[2]['value'] != undefined ? popUpData[2]['value'] : '-';  
      name = formattedRivergaugeData['popupData']['title']!= undefined ? formattedRivergaugeData['popupData']['title'] : '-';  
      district = formattedRivergaugeData['popupData']['subTitle'].split(",")[1]; 
      block = formattedRivergaugeData['popupData']['subTitle'].split(",")[0];
      basin = formattedRivergaugeData['popupData']['subTitle2'].split(",")[1];
      lat = geoData['latitude']!= undefined ? this.utilsSrv.getDecimalFixed(parseFloat(geoData['latitude'])) : '-';  
      long = geoData['longitude']!= undefined ? this.utilsSrv.getDecimalFixed(parseFloat(geoData['longitude'])) : '-';
      // console.log('aggrData res popUpData :::',popUpData,'\n', popUpData[1]['value']);
    }
    else{
      level = '-'; 
      depth = '-' 
      name = properties.hasOwnProperty('point_na_1') ? properties['point_na_1']  : '-';
      trend =  '-';  
      basin = properties.hasOwnProperty('basin') ? properties['basin'] : '-'; 
      lat = properties.hasOwnProperty('latitude') ? this.utilsSrv.getFiveDecimalFixed(properties['latitude']):' - ';  
      long = properties.hasOwnProperty('longitude') ? this.utilsSrv.getFiveDecimalFixed(properties['longitude']):' - ';
    }
    var htmlString = "<html><body>";
    htmlString += '<div class="alert-poupup-table">';
    htmlString += `<div class="card-body p-0">
       <table class="table table-sm m-0 table-bordered ">`;
    htmlString += `<tbody>
       <tr>
         <th>Reservoir Name</th>
         <td>${ name ? name : '-'}</td>
       </tr>
       <tr>
       <th> Basin </th>
            <td>${ basin ? basin : '-'}</td>
      </tr>
       <tr>
       <th> District </th>
            <td>${ district ? district : '-'}</td>
      </tr>
      <tr>
       <th> Mandal </th>
            <td>${ block ? block : '-'}</td>
      </tr>
      <tr>
      <th> Design Capacity (TMC)</th>
            <td>${ capacity ? capacity : '-'}</td>
      </tr>
      <tr>
      <th> Current Level (m)</th>
            <td>${ level ? level : '-'}</td>
      </tr>
      <tr>
      <th> Current Storage </th>
            <td>${ storage ? storage : '-'}</td>
      </tr>
      <tr>
      <th> Latitude </th>
            <td>${ lat ? lat : '-'}</td>
      </tr>
      <tr>
      <th> Longitude </th>
            <td>${ long ? long : '-'}</td>
      </tr>
       <tr><a class="seemore${properties['uuid']}" style="width:100%;display:block;text-align:right;text-decoration: nonerfLevel;font-size:10px">See More <i class="bi bi-chevron-right"></i></a></tr>
     </table>
   </div>
   </div>`;
    return htmlString;
  }
  getIconBasedOnCondition(condition: string): L.DivIcon {
  let iconClass = ''; // Default class
  let iconColor = 'red'; // Default color

  if (condition === 'square') {
    iconClass = 'square';
  } else if (condition === 'triangle') {
    iconClass = 'triangle';
  } else if (condition === 'hexagon') {
    iconClass = 'hexagon';
  } else {
    iconClass = 'square'; // Default to square if no condition is matched
  }

  return L.divIcon({
    className: `leaflet-div-icon ${iconClass}`, // Add the class dynamically
    html: '', // We don't need to add text to the icon for shapes like triangle/hexagon
    iconSize: [40, 40], // Adjust icon size if necessary
    iconAnchor: [20, 40], // Position the icon's anchor point
    popupAnchor: [0, -40] // Position of popup (optional)
  });
}


  setHtmlContentForCity(formattedRivergaugeData, properties){
    let name,basin,district,area,lat,long;
    if( properties != undefined){
      name = properties['tn_name'] ? properties['tn_name'] : '-';
      district = properties['dis_name']; 
      area = properties['mun_area'] ? this.utilsSrv.getDecimalFixed(properties['mun_area']) : '-';
      lat = properties['lat']!= undefined?this.utilsSrv.getDecimalFixed(properties['lat']) : '-';  
      long = properties['long']!= undefined?this.utilsSrv.getDecimalFixed(properties['long']): '-';  
    }
    var htmlString = "<html><body>";
    htmlString += '<div class="alert-poupup-table">';
    htmlString += `<div class="card-body p-0">
       <table class="table table-sm m-0 table-bordered ">`;
    htmlString += `<tbody>
       <tr>
         <th>Name</th>
         <td>${ name ? name : '-'}</td>
       </tr>
       <tr>
       <th> District </th>
            <td>${ district ? district : '-'}</td>
      </tr>
      <tr>
      <th> Area (SqKm)</th>
            <td>${ area ? area : '-'}</td>
      </tr>
      <tr>
      <th> Latitude </th>
            <td>${ lat ? lat : '-'}</td>
      </tr>
      <tr>
      <th> Longitude </th>
            <td>${ long ? long : '-'}</td>
      </tr>
       <tr><a class="seemore${properties['ulb_uuid']}" style="width:100%;display:block;text-align:right;text-decoration: nonerfLevel;font-size:10px">See More <i class="bi bi-chevron-right"></i></a></tr>
     </table>
   </div>
   </div>`;
    return htmlString;
  }

  getFillColor(fill) {
    fill = parseFloat(fill);
    if (fill >= 90) {
      return '#003399';
    } else if (fill >= 80) {
      return '#3399ff';
    } else if (fill >= 60) {
      return '#33cccc';
    } else if (fill >= 40) {
      return '#ff9f80';
    } else if (fill >= 20) {
      return '#ff6600';
    } else if (fill < 20) {
      return '#cc3300';
    } else if (!fill) {
      return 'gray';
    }
  }

  getFloodConditionColor(floodCondition : any){
    let color : any ;
    if(floodCondition == 'flood_warnings'){
      return color = '#FFCD39';
    }else if(floodCondition == 'severe_flood_warnings'){
      return color = '#FD7E14';
    }else if(floodCondition == 'serious_flood_warnings'){
      return color = '#DC3545';
    }
  }


  async formatForecastHeatMapLayers(gisMapComp) {
    let params : any = gisMapComp.params;
    const heatMapLayers = await this.getHeatMapLayers(gisMapComp);
    console.log("heatmaplayers ::::",heatMapLayers);
    this.setForecastHeatMapLayer(heatMapLayers, gisMapComp).then((timeLayers: any) => {
      for (let timeLinePos in timeLayers) {
        let heatMapLayer = timeLayers[timeLinePos];
        let legendData = this.dataService.deepClone(AlertMapConstants.LegendActual);
        legendData.colorValues = legendData.colorValues ? legendData.colorValues.reverse() : [];
        heatMapLayer.options.legendData = legendData;
        this.setForecastHeatMapToMap(gisMapComp,heatMapLayer.options.groupName,heatMapLayer,timeLinePos);
      }
      let layerObj = gisMapComp.layers.overlaylayers[timeLayers[0].options.groupName.toString()];
      if(!isNullOrUndefined(layerObj) && (timeLayers[0].options.groupName.toString() == layerObj.options.groupName.toString()) )
        {
          layerObj.options.visible = true;
          layerObj.options.hasLegend = true;
          layerObj.options.legendName = 'ObservedDaily';
          if (layerObj.options.visible === true) {
            console.log('layerObj ::',layerObj);
            gisMapComp.map.addLayer(layerObj)
            gisMapComp.activeLayers[layerObj.options.groupName.toString()] = true;
            gisMapComp.activeGroup = layerObj.options.groupName;
            gisMapComp.manageLegend();
          }
        }
        gisMapComp.playButtonDisable = false;
    }, (error => {
      console.log('error ::',error)
    }));
  }

  getLabelStringsForPlayBarAnimation(gisMapComp)
  {
    return this.labelStrings;
  }

  setForecastHeatMapToMap(gisMapComp,groupName,heatMapLayer,layerPos) {
    let heatMaplayer = heatMapLayer;
    if (heatMaplayer != undefined || null) {
      let heatMap :any = {}
      heatMap[groupName] = heatMapLayer;
      gisMapComp.addSrcWiseHeatmapLayersInflowforecast(heatMap);
      gisMapComp.activeLayers[groupName] = layerPos == '0' ? true : false;
    }
    else {
      console.error("No Heatmap Found");
    }
  }

  changeTimeLayers(gis, groupName) {
    if (groupName != gis.activeGroup) {
      let oldGroupName = gis.activeGroup
      gis.activeGroup = groupName;
      this.removeGroupTimeLayers(gis, oldGroupName);
      this.addGroupTimeLayers(gis, groupName);
    }
  }

  addGroupTimeLayers(gisMapComp, groupName) {
    let layerObj = gisMapComp.layers.overlaylayers[groupName.toString()];
    let index : any = this.labelStrings.findIndex((a: any)=> a.groupName==groupName);
    let legendName : any = 'ObservedHourly';
    if(index != -1){
      let layerType : any = this.labelStrings[index].type;
      // console.log('layerType :::',layerType,index,this.labelStrings[index].realCategory);
      if(layerType == "observed" && this.labelStrings[index].realCategory == undefined){
        legendName = 'ObservedDaily';
      }else if(layerType == "nowcast" && (this.labelStrings[index].realCategory != undefined && this.labelStrings[index].realCategory != 'forecast')){
        legendName = 'ObservedHourly';
      }else if(layerType == "nowcast" && this.labelStrings[index].realCategory == 'forecast'){
        legendName = 'forecastHourly';
      }else{
        legendName = 'ObservedDaily';
      }
    }
    if(!isNullOrUndefined(layerObj))
    {
      layerObj.options.visible = true;
      layerObj.options.hasLegend = true;
      layerObj.options.legendName = legendName;
      if (layerObj.options.visible === true) {
        gisMapComp.map.addLayer(layerObj)
        gisMapComp.activeLayers[groupName.toString()] = true;
        gisMapComp.activeGroup = groupName;
        gisMapComp.manageLegend();
      }
    }
  }

  removeGroupTimeLayers(gisMapComp, groupName) {
    if (gisMapComp.map.hasLayer(gisMapComp.layers['overlaylayers'][groupName.toString()])) {
      gisMapComp.map.removeLayer(gisMapComp.layers['overlaylayers'][groupName.toString()]);
      let layerObj = gisMapComp.layers.overlaylayers[groupName.toString()];
      layerObj.options.visible = false;
       layerObj.options.hasLegend = false
       delete layerObj.options.legendName;
      gisMapComp.activeLayers[groupName.toString()] = false;
    }
  }

  async getForecastHeatMapLayers(gisMapComp, params) {
    let layerList = [];
    layerList = layerList.concat(this.createHeatMapLayers(params.src,gisMapComp));
    return layerList;
  }

  get10DaysTimeStamps() {
      const today = new Date();
      const refTs = today.getTime();
      const start = new Date(refTs);
      start.setHours(5, 30, 0, 0);
      const dayStartTs = start.getTime();
      const blocks = {};
      for (let i = 0; i < 7; i++) {
        blocks[i] = {};
        blocks[i]['timeStamp'] = dayStartTs + ((i) * 86400000);
        blocks[i]['timeLineName'] = {};
        blocks[i]['timeLineName']['label'] = this.convetTimeStampToDay(blocks[i]['timeStamp']);
        blocks[i]['timeLineName']['toolTip'] = '5:30 AM - 5:30 AM';
        blocks[i]['leftSideName'] = this.convetTimeStampToDay(blocks[i]['timeStamp']);
        blocks[i]['timeLinePos'] = i;
      }
      return blocks;
  }

  async getHeatMapLayers(gisMapComp) {
    let layerList = [];
    // layerList = layerList.concat(this.create24HeatMapLayers());
    // layerList = layerList.concat(this.create10HeatMapLayers(gisMapComp));
    let observedHourlyLayers : any = await this.dataService.getAlertsHourlyHeatmaps().toPromise();
    let observedDailyLayers : any = await this.dataService.getAlertsDailyHeatmaps().toPromise();
    let nowcastLayers : any = await this.dataService.getNowcastHeatmaps().toPromise();
    let forecastHourlyLayers : any = await this.dataService.getAlertsForecastHourlyHeatmaps(gisMapComp.params['source']).toPromise();
    let forecastDailyLayers : any = await this.dataService.getAlertsForecastDailyHeatmaps(gisMapComp.params['source']).toPromise();
    layerList.concat(observedDailyLayers,observedHourlyLayers,nowcastLayers,forecastHourlyLayers,forecastDailyLayers);
    let list = [
      ...Object.entries(observedHourlyLayers).map(([key, value]) => ({ [key]: value })),
      ...Object.entries(observedDailyLayers).map(([key, value]) => ({ [key]: value })),
      ...Object.entries(nowcastLayers).map(([key, value]) => ({ [key]: value })),
      ...Object.entries(forecastHourlyLayers).map(([key, value]) => ({ [key]: value })),
      ...Object.entries(forecastDailyLayers).map(([key, value]) => ({ [key]: value }))
    ];
    console.log('heatMaplayers ::::',list)
    // if (this.meanMedian == 'mean') {
    //   layerList = layerList.concat(this.createMeanWeeklyHeatMapLayers());
    // }
    // else {
    //   layerList = layerList.concat(this.createMedianWeeklyHeatMapLayers());
    // }
    return list;
  }

  create24HeatMapLayers() {
    const tsarray: any = this.get24HrsTimeStamps();
    const urls: any = [];
    for (const i in tsarray) {
      const layerObj = { ...AlertMapConstants.HeatMapOptions };
      if (i == '4') {
        layerObj['url'] ="https://tnwrims.vassarlabs.com/wrimsApi/api/" + 'weatherForecastv2/getHeatMapData/'+ 'ECMWF' +
          '/' + 'ECMWF' + '/' + 'RAINFALL' + '/' + tsarray[i]['timeStamp'] + '/' + '24' + '/24hr' + "/ts_color" +'/'+null+'/'+'/'+'e98cd5b7-6556-4c0f-a778-3429e1c14a6b'+'?clientUUID='+'7ca64e9c-5c67-4929-b88d-e7448551540f';
        layerObj['groupName'] = '24hr';
        layerObj['setDefault'] = 'true';
      } else {
        layerObj['url'] = "https://tnwrims.vassarlabs.com/wrimsApi/api/" + 'weatherForecastv2/getHeatMapData/'+
          '/' + 'ECMWF' + '/' + 'RAINFALL' + '/' + tsarray[i]['timeStamp'] + '/' + '24' + '/6hr' + "/ts_color"+'/'+null+'/'+'/'+'e98cd5b7-6556-4c0f-a778-3429e1c14a6b'+'?clientUUID='+'7ca64e9c-5c67-4929-b88d-e7448551540f';
        layerObj['groupName'] = tsarray[i]['timeStamp'].toString();
        layerObj['setDefault'] = 'false';
      }
      layerObj['stateName'] = 'TAMILNADU';
      layerObj['time'] = '24';
      layerObj['view'] = 'Admin';
      layerObj['timeLineName'] = tsarray[i]['timeLineName'];
      layerObj['timeLinePos'] = tsarray[i]['timeLinePos'];
      layerObj['leftSideName'] = tsarray[i]['leftSideName'];
      urls.push(layerObj);
      const basinLayerObj = { ...layerObj };
      basinLayerObj['view'] = 'Basin';
      urls.push(basinLayerObj);
    }
    return urls;
  }

  create10HeatMapLayers(gisMapComp) {
    let groupNameToBlockMap :any ={}
    this.labelStrings = [];
    const tsarray: any = this.get10DaysTimeStamps();
    const urls: any = [];
    for (const i in tsarray) {
      const layerObj = { ...AlertMapConstants.HeatMapOptions };
      layerObj['url'] = "https://tnwrims.vassarlabs.com/wrimsApi/api/" + 'weatherForecastv2/getHeatMapData/' + 'ECMWF' +
        '/' + 'ECMWF' + '/' + 'RAINFALL' + '/' + tsarray[i]['timeStamp'] + '/' + '10' + '/day' + "/ts_color"+'/'+null+'/'+'/'+'e98cd5b7-6556-4c0f-a778-3429e1c14a6b'+'?clientUUID='+'7ca64e9c-5c67-4929-b88d-e7448551540f';
      layerObj['groupName'] = tsarray[i]['timeStamp'].toString();
      if (i == '0') {
        layerObj['setDefault'] = 'true';
      } else {
        layerObj['setDefault'] = 'false';
      }
      layerObj['stateName'] = 'TAMILNADU';
      groupNameToBlockMap[tsarray[i]['timeStamp'].toString()] = i;
      layerObj['view'] = 'Admin';
      layerObj['time'] = '10';
      layerObj['timeLineName'] = tsarray[i]['timeLineName'];
      layerObj['timeLinePos'] = tsarray[i]['timeLinePos'];
      layerObj['leftSideName'] = tsarray[i]['leftSideName'];
      urls.push(layerObj);
      const basinLayerObj = { ...layerObj };
      basinLayerObj['view'] = 'Basin';
      this.labelStrings[i] = {label: {label: tsarray[i]['timeLineName']['label'], toolTip : tsarray[i]['timeLineName']['toolTip']} ,fullLabel : tsarray[i]['timeLineName']['toolTip'], groupName: tsarray[i]['timeStamp'].toString()};
      urls.push(basinLayerObj);
    }
    gisMapComp.labelStrings = this.labelStrings;
    gisMapComp.groupNameToBlockMap = groupNameToBlockMap;
    gisMapComp.blockNumber = 0;
    this.gisUtils.setBlockNumber(gisMapComp.blockNumber );
    this.gisUtils.setPlayButton(gisMapComp.blockNumber );
    return urls;
  }


  get24HrsTimeStamps() {
    const today = new Date();
    const refTs = today.getTime();
    const start = new Date(refTs);
    start.setHours(5, 30, 0, 0);
    const dayStartTs = start.getTime();
    const blockIndex = Math.floor((refTs - dayStartTs) / 21600000);
    const blocks = {};
    for (let i = 0; i < 4; i++) {
      blocks[i] = {};
      blocks[i]['timeStamp'] = dayStartTs + ((i + blockIndex) * 21600000);
      blocks[i]['timeLineName'] = {};
      blocks[i]['timeLineName']['toolTip'] = this.convertTimestampToFullBlockValue(blocks[i]['timeStamp']);
      blocks[i]['timeLineName']['label'] = this.convertTimestampToBlockValue(blocks[i]['timeStamp']);
      blocks[i]['leftSideName'] = this.convertTimestampToFullBlockValue(blocks[i]['timeStamp']);
      blocks[i]['timeLinePos'] = i;
    }
    blocks[4] = {};
    blocks[4]['timeStamp'] = blocks[0]['timeStamp'];
    blocks[4]['timeLineName'] = {};
    blocks[4]['timeLineName']['toolTip'] = this.convertTimestampToBlockValue(blocks[0]['timeStamp']) + '-' + this.convertTimestampToBlockValue(blocks[0]['timeStamp']);
    blocks[4]['timeLineName']['label'] = '24hr';
    blocks[4]['leftSideName'] = '24hr';
    blocks[4]['timeLinePos'] = 4;
    return blocks;
  }

  convertTimestampToBlockValue(ts) {
    ts = Number(ts);
    let hours = new Date(ts).getHours();
    const minutes = new Date(ts).getMinutes();
    let amPm = 'A.M';
    if(hours == 12)
    {
      hours = 12;
      amPm = 'P.M';
    }
    if (hours > 12) {
      hours = hours - 12;
      amPm = 'P.M';
    }
    return hours.toString() + ':' + minutes.toString() + ' ' + amPm;
  }
  convertNowcastTimestampToFullBlockValue(ts) {
    ts = Number(ts);
    let starthours = new Date(ts).getHours();
    const startminutes = new Date(ts).getMinutes();
    let startAmPm = 'A.M';
    if (starthours == 12) {
      starthours = starthours;
      startAmPm = 'P.M';
    }
    if (starthours > 12) {
      starthours = starthours - 12;
      startAmPm = 'P.M';
    }
    let endhours = new Date(ts + ProjConstants.MILLIS_IN_1HOUR).getHours();
    const endminutes = new Date(ts + ProjConstants.MILLIS_IN_1HOUR).getMinutes();
    let endamPm = 'A.M';
    if (endhours == 12) {
      endhours = endhours;
      endamPm = 'P.M';
    }
    if (endhours > 12) {
      endhours = endhours - 12;
      endamPm = 'P.M';
    }
    return starthours.toString() + ':' + startminutes.toString() + ' ' + startAmPm + ' - ' + endhours.toString() + ':' + endminutes.toString() + ' ' + endamPm;
  }
  convertTimestampToFullBlockValue(ts) {
    ts = Number(ts);
    let starthours = new Date(ts).getHours();
    const startminutes = new Date(ts).getMinutes();
    let startamPm = 'A.M';
    if (starthours > 12) {
      starthours = starthours - 12;
      startamPm = 'P.M';
    }
    let endhours = new Date(ts + ProjConstants.MILLIS_IN_6HOURS).getHours();
    const endminutes = new Date(ts + ProjConstants.MILLIS_IN_6HOURS).getMinutes();
    let endamPm = 'A.M';
    if (endhours > 12) {
      endhours = endhours - 12;
      endamPm = 'P.M';
    }
    return starthours.toString() + ':' + startminutes.toString() + ' ' + startamPm + ' - ' + endhours.toString() + ':' + endminutes.toString() + ' ' + endamPm;
  }

  pickStartTimeFromSource(source) {
    if (source == "IMD Merged") {
      source = "IMD";
    }
    return AlertMapConstants[source + "_START_TIME"];
  }

  convetTimeStampToDay(ts) {
    const date = new Date(ts).toLocaleDateString();
    let dateObj : any = new Date(ts);
    let hours = dateObj.getHours();
    let hh = hours < 10 ? "0" + hours : hours;
    let minutes = dateObj.getMinutes();
    let mm = minutes < 10 ? "0" + minutes : minutes;
    let changedate: any = date.toString().split('/', 3);
    changedate = String(changedate[0] + '/' + changedate[1]  + '/'+ changedate[2] + " "+  hh+ ":" + mm );
    return changedate;
  }
  SOURCE_WISE: any = {
    ['IMD_MERGED']: {
      PrimarySourceType: 'IMD_SHORT_RANGE',
      SecondarySourceType: 'IMD_LONG_RANGE',
    },
    ['ECMWF']: {
      PrimarySourceType: 'ECMWF',
      SecondarySourceType: 'ECMWF',
    },
    // [InflowForecastConstant.IBM_GRAF]: {
    //   PrimarySourceType: InflowForecastConstant.IBM_GRAF,
    //   SecondarySourceType: 'null',
    // }
  };
  createHeatMapLayers(primary,gisMapComp) {
    primary = 'ECMWF';
    let groupNameToBlockMap :any ={}
    this.labelStrings = [];
    const tsarray: any = this.get10DaysTimeStamps();
    let source = this.SOURCE_WISE[primary];
    let primarysource = source.PrimarySourceType;
    let secondarysource = source.SecondarySourceType;
    const urls: any = [];
    for (const i in tsarray) {
      const layerObj = { ...AlertMapConstants.forecastHeatMapOptions };
      layerObj['url'] ="https://tnwrims.vassarlabs.com/wrimsApi/api/" + 'weatherForecastv2/getHeatMapData/' + primarysource +
        '/' + secondarysource + '/' + 'RAINFALL' + '/' + tsarray[i]['timeStamp'] + '/' + '10' + '/day' + '/ts_color'+'/'+null+'/'+'e98cd5b7-6556-4c0f-a778-3429e1c14a6b'+'?clientUUID='+'7ca64e9c-5c67-4929-b88d-e7448551540f';
      layerObj['groupName'] = tsarray[i]['timeStamp'].toString();
      groupNameToBlockMap[tsarray[i]['timeStamp'].toString()] = i;
      layerObj['setDefault'] = 'false';
      layerObj['animationType'] = 'Time';
      layerObj['view'] = 'Basin';
      layerObj['time'] = '24';
      layerObj['timeLineName'] = tsarray[i]['timeLineName'];
      layerObj['timeLinePos'] = tsarray[i]['timeLinePos'];
      layerObj['leftSideName'] = tsarray[i]['leftSideName'];
      this.labelStrings[i] = {label: {label: tsarray[i]['timeLineName']['label'], toolTip : tsarray[i]['timeLineName']['toolTip']} ,fullLabel : tsarray[i]['timeLineName']['toolTip'], groupName: tsarray[i]['timeStamp'].toString()};
      urls.push(layerObj);
    }
    gisMapComp.labelStrings = this.labelStrings;
    gisMapComp.groupNameToBlockMap = groupNameToBlockMap;
    gisMapComp.blockNumber = 0;
    this.gisUtils.setBlockNumber(gisMapComp.blockNumber );
    this.gisUtils.setPlayButton(gisMapComp.blockNumber );
    return urls;
  }

  setForecastHeatMapLayer(heatMapLayers, gisMapComp) {
    let params: any = gisMapComp.params;
    let layerPromise = new Promise((resolve, reject) => {
      this.getShapeBoundaryLayers('Admin', true, 'A', params).then(clipData => {
        this.forecastTimeLayers = {};
        let calledLayers = [];
        let timeLayers = {};
        let groupNameToBlockMap: any = {}
        this.labelStrings = [];
        let dataList: any = [];
        let i = 0;
        let updatedLayers: any = [];
        for (let layer of heatMapLayers) {
          let date: any = (Object.keys(layer)[0]).toString();
          let timeStamp: any;
          let block: any = {};
          if (date.length == 8) {
            timeStamp = this.utilsSrv.getTimeStampForDate(date);
          } else {
            timeStamp = date;
          }
          let Obj: any = {};
          Obj[timeStamp] = layer[date];
          updatedLayers.push(Obj);
        }
        const sortedByKey = updatedLayers.sort((a, b) => {
          const keyA = Object.keys(a)[0];
          const keyB = Object.keys(b)[0];
          return keyA.localeCompare(keyB); // Sorting alphabetically by key
        });
        let currentTimeStamp = new Date()
        // Get today's date and set the time to 8:30 AM
        let todayMorning = new Date(currentTimeStamp.getFullYear(), currentTimeStamp.getMonth(), currentTimeStamp.getDate(), 8, 30, 0).getTime();

        if (currentTimeStamp.getTime() < todayMorning) {
          todayMorning = todayMorning - (24 * 60 * 60 * 1000)
        }
        todayMorning = todayMorning - 1;
        let category: any;
        let realTimeCategory: any;
        console.log('sortedByKey :::', sortedByKey);
        for (let layer of updatedLayers) {
          let date: any = (Object.keys(layer)[0]).toString();
          if (this.isWithinNowcastRange(Number(date))) {
            category = 'nowcast'
            realTimeCategory = this.getRealTimeCategory(Number(date))
          } else {
            if (Number(date) < todayMorning) {
              category = 'observed'
            } else if (Number(date) > todayMorning) {
              category = 'forecast'
            }
          }
          let block: any = {};
          block['timeLineName'] = {};
          block['timeLineName']['label'] = this.convetTimeStampToDay(Number(date));
          block['timeLineName']['toolTip'] = '5:30 AM - 5:30 AM';
          block['leftSideName'] = this.convetTimeStampToDay(Number(date));
          block['timeLinePos'] = i.toString();
          const layerObj = { ...AlertMapConstants.HeatMapOptions };
          layerObj['groupName'] = date;
          if (i == 0) {
            layerObj['setDefault'] = 'true';
          } else {
            layerObj['setDefault'] = 'false';
          }
          layerObj['stateName'] = 'ANDHRAPRADESH';
          groupNameToBlockMap[date] = i;
          layerObj['view'] = 'Admin';
          layerObj['time'] = '10';
          layerObj['timeLineName'] = block['timeLineName'];
          layerObj['timeLinePos'] = block['timeLinePos'];
          layerObj['leftSideName'] = block['leftSideName'];
          layerObj['category'] = category;
          const basinLayerObj = { ...layerObj };
          basinLayerObj['view'] = 'Basin';
          this.labelStrings[i] = { label: { label: block['timeLineName']['label'], toolTip: block['timeLineName']['toolTip'] }, fullLabel: block['timeLineName']['toolTip'], groupName: date, type: category, realCategory: realTimeCategory, isMerged: true};
          i = i + 1;
          dataList[date] = layer[date];
          calledLayers.push(basinLayerObj);
        }
        this.labelStrings = this.updateLabelStrings(this.labelStrings)
        gisMapComp.labelStrings = this.labelStrings;
        gisMapComp.groupNameToBlockMap = groupNameToBlockMap;
        gisMapComp.blockNumber = 0;
        this.gisUtils.setBlockNumber(gisMapComp.blockNumber);
        this.gisUtils.setPlayButton(gisMapComp.blockNumber);
        for (let index in calledLayers) {
          let layer = calledLayers[index];
          let data = dataList[layer.groupName] ? dataList[layer.groupName] : null;
          if (!isNullOrUndefined(data)) {
            let timeLayer: any = this.dataService.deepClone(AlertMapConstants.Default_HeatMap_Layer_Constant);

            timeLayer.options['clip'] = clipData;
            if (!this.utilsSrv.isEmptyObj(data)) {
              let anchors : any;
              if(layer.category == 'observed'){
                anchors = this.getImageBounds({
                  "southWest": {
                    "latitude": 12.60004,
                    "longitude": 76.75599
                  },
                  "northEast": {
                    "latitude": 19.15689,
                    "longitude": 84.76102
                  }
                });
              }else if(layer.category != 'observed'){
                anchors = this.getImageBounds({
                  "southWest": {
                    "latitude": 4.96,
                    "longitude": 64.96
                  },
                  "northEast": {
                    "latitude": 40.04,
                    "longitude": 100.04
                  }
                })
              }
              timeLayer.imageBounds = anchors;
              timeLayer.imageUrl = data;
              timeLayer.options.groupName = layer.groupName;
              timeLayers[layer.timeLinePos] = timeLayer;
              timeLayer.options.displayName = this.utilsSrv.getSimpleDateStringWithoutTime(Number(layer.groupName));
              timeLayer.options.name = timeLayer.options.displayName;
            }
          }
        }
        console.log('timeLayers :::', timeLayers);
        resolve(timeLayers);
      }, (error) => {
        console.log(error);
      });

    });

    return layerPromise;
  }

  updateLabelStrings(data: any[]): any[] {    
    const forecastItems = data.filter(item => item.type === "forecast");

    if (forecastItems.length > 3) {
      // Get the index of the fourth last forecast item
      const fourthLastIndex = data.lastIndexOf(forecastItems[forecastItems.length - 4]);

      // Change it to "nowcast" if it's "forecast"
      if (fourthLastIndex !== -1 && data[fourthLastIndex].type === "forecast") {
        data[fourthLastIndex].type = "nowcast";
      }
    }

    // Step 1: Find the index of the first occurrence
    const firstIndex = data.findIndex(item => item.type === 'nowcast' && item.realCategory === 'observed' && item.groupName === this.getTodayMorningTimestamp());

    // Step 2: Filter all nowcast-observed objects
    const nowcastObserved = data.filter(item => item.type === 'nowcast' && item.realCategory === 'observed' && item.groupName != this.getTodayMorningTimestamp());

    // Step 3: Create a grouped object for them
    const groupedNowcast = {
      label: {
        label: this.convetTimeStampToDay(Number(this.getTodayMorningTimestamp())),
        toolTip: "Nowcast Observed"
      },
      fullLabel: "Grouped Nowcast",
      type: "observed",
      realCategory: "observed",
      isMerged: true,
      groupName: this.getTodayMorningTimestamp(),
      children: nowcastObserved
    };

    // Step 4: Filter out the grouped items from the main array
    // let remainingData = data;//data.filter(item => !(item.type === 'nowcast' && item.realCategory === 'observed'));

    // console.log("firstIndex",firstIndex,nowcastObserved,groupedNowcast);
    
    // Step 5: Insert the grouped object at the found index
    if (firstIndex !== -1) {
      let remainingData = data.filter(item => !(item.type === 'nowcast' && item.realCategory === 'observed'));
      remainingData.splice(firstIndex, 0, groupedNowcast);
      return remainingData
    } else {
      return data
    }

    // console.log("remainingData",remainingData);
    
    // return remainingData;
  }

  getTodayMorningTimestamp() {
    const now = new Date();
    // console.log("now.getHours()",now.getHours(),now.getMinutes());
    let todayMorning = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 8, 30, 0);
    if(now.getHours() < 8 && now.getMinutes() < 30) {
      todayMorning = new Date(now.getFullYear(), now.getMonth(), now.getDate()-1, 8, 30, 0);
    }
    return todayMorning.getTime().toString();
  }

  isSameDay(timestamp1: number, timestamp2: number): boolean {
    const date1 = new Date(timestamp1);
    const date2 = new Date(timestamp2);
  
    // Check if year, month, and day match, but hours are different
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  }

  isWithinNowcastRange(timestamp: number): boolean {
    const now = new Date();
  
    // Get today's date and set the time to 8:30 AM
     let todayMorning = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 8, 30, 0).getTime();

    if(now.getTime() < todayMorning){
      todayMorning = todayMorning - (24 * 60 * 60 * 1000)
    }
  
    // Get tomorrow's date and set the time to 8:30 AM
    const tomorrowMorning = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 8, 30, 0).getTime();    
  
    // Check if the given timestamp falls within the range
    return timestamp >= todayMorning && timestamp < tomorrowMorning;
  }

  getRealTimeCategory(inputTimestamp: number): string {
    const currentTime = new Date().getTime();
    const inputTime = new Date(inputTimestamp);
  
    // const currentDate = currentTime.getDate();
    // const inputDate = inputTime.getDate();
  
    const currentHour = new Date(currentTime).getHours() + 1;
    const inputHour = inputTime.getHours();    
  
    if (inputTimestamp > currentTime) {
      if(currentHour == inputHour){
        return 'nowcast'
      } else {
        return "forecast"; // Any timestamp from tomorrow
      }
    } else if (inputTimestamp < currentTime) {
      return "observed"; // Past hours of today
    } else if (inputTimestamp === currentTime) {
      return "nowcast"; // Current hour
    } else {
      return "forecast"; // Future hours of today
    }
  }

  getImageBounds(boundObj) {
    let imageBounds = [];
    let latlongs = [];
    latlongs.push(boundObj['southWest']['latitude']);
    latlongs.push(boundObj['southWest']['longitude']);
    imageBounds.push(latlongs);
    latlongs = [];
    latlongs.push(boundObj['northEast']['latitude']);
    latlongs.push(boundObj['northEast']['longitude']);
    imageBounds.push(latlongs);
    var anchors = [];
    anchors.push([imageBounds[1][0], imageBounds[0][1]])
    anchors.push([imageBounds[1][0], imageBounds[1][1]])
    anchors.push([imageBounds[0][0], imageBounds[1][1]])
    anchors.push([imageBounds[0][0], imageBounds[0][1]])
    return anchors;
  }

  getShapeBoundaryLayers(view, clip, stateName, params) {
    const shapeBoundary = new Promise((resolve, reject) => {
      if (clip == false) {
        resolve(null);
      }
      let boundaryURL;
      let layerName;

      // if (view == 'Admin') {
        layerName = 'HEATWAVE:AP_STATE_BOUNDARY';//MapConstants.GEOSERVER_WORKSPACE_NAME + ':' + InflowForecastConstant.STATE_BOUNDARY;
      // } else {
      //   layerName = 'tamilnadu:tamilnadu_state';//MapConstants.GEOSERVER_WORKSPACE_NAME + ':' + InflowForecastConstant.BASIN_BOUNDARY;
      // }

      boundaryURL = 'http://acerkrishidss.vassarlabs.com/new-geoserver/' + 'HEATWAVE' + AlertMapConstants.GEOJSON_URL + '&typeName=' + layerName;// + "&cql_filter=uuid='" + params.basin + "'" //+ '&viewParams=stateName:' + stateName;
      let stateBoundary: any;
      this.http.get(boundaryURL).subscribe(boundaryData => {
        if (boundaryData) {
          stateBoundary = boundaryData['features'][0]['geometry'];
          resolve(stateBoundary)
        } else {
          resolve(stateBoundary)
        }
      });
    });
    return shapeBoundary;
  }

  getMiTanksData(params): Promise<any> {
    let response = {};
    let postData = this.dataService.getPostDataTanksCount(params);
    let promise = new Promise((resolve, reject) => {
      this.dataService.post(VisibilityMapConstants.API_MAPPING.MITANK_COUNT, postData).subscribe((data) => {
        if (data && (Object.keys(data)).length > 0) {
          response = this.preProcessData(data);
        }
        resolve(response);
      }),
        err => {
          console.log("Error Occurred", err);
          reject(response);
        }
    });
    return promise;
  }

  getMiTanksMandalData(params,gisMapComp): Promise<any> {
    let response = {};
    let postData = this.dataService.getPostDataTanksCount(params);
    if (params['view'] == VisibilityMapConstants.VIEWS.ADMIN &&  postData['pType'] == 'STATE') {
      postData['cType'] = VisibilityMapConstants.LOCATIONS.BLOCK;
    }
    else if (params['view'] == VisibilityMapConstants.VIEWS.BASIN &&  postData['pType'] == 'STATE') {
      postData['cType'] = VisibilityMapConstants.LOCATIONS.SUBBASIN;
    }    
    let promise = new Promise((resolve, reject) => {
      this.dataService.post(VisibilityMapConstants.API_MAPPING.MITANK_COUNT, postData).subscribe((data) => {
        
        if (data && (Object.keys(data)).length > 0) {
          gisMapComp.showThrobber = false
          response = this.preProcessData(data);
        }
        resolve(response);
      }),
        err => {
          console.log("Error Occurred", err);
          gisMapComp.showThrobber = false
          reject(response);
        }
    });
    return promise;
  }

  priorityOrder: string[] = ["Extreme Danger", "Danger", "Warning", "Caution", "Normal"];
  preProcessData(data) {
    let response = {};
    let keys : any = data ? Object.keys(data) : [];
    for (let i of keys) {
      let row : any = {};
      row = data[i] && data[i]['MITANK']? data[i]['MITANK'] : {}; 
      let key = i;
      let count : any;
      let color : any = '#ffffff', clusterColor = "#f4faff";
      let normalCnt :  any = row['Normal']!=undefined ? row['Normal'] : null;
      let cautionCnt :  any = row['Caution']!=undefined ? row['Caution'] : null;
      let dangerCnt :  any = row['Danger']!=undefined ? row['Danger'] : null;
      let extremeDangerCnt :  any = row['Extreme Danger']!=undefined ? row['Extreme Danger'] : null;
      let warningCnt :  any = row['Warning']!=undefined ? row['Warning'] : null;
      let maxVals : any = this.getPriorityValue(row)
      count = maxVals && maxVals.value ? maxVals.value : null;
      color = this.getMiTanksColor(maxVals ? maxVals.key : 'no_data');
      // console.log("color :::",color,"\n count :::",count,"\n maxValues :::",maxVals)
      response[key] = {
        count: count == null ? '-' : count,
        color: color,
        clusterColor: '#000000',
        warningCnt : warningCnt == null ? '-' : warningCnt,
        normalCnt : normalCnt == null ? '-' : normalCnt,
        cautionCnt : cautionCnt == null ? '-' : cautionCnt,
        dangerCnt : dangerCnt == null ? '-' : dangerCnt,
        extremeDangerCnt : extremeDangerCnt == null ? '-' : extremeDangerCnt,
      }
    }
    return response;
  }

  // Function to get the first key-value pair based on priority and non-zero value
  getPriorityValue(data:any): any {
    for (let key of this.priorityOrder) {
      if (data[key] > 0) {
        return {'key' : key, 'value':data[key]};
      }
    }
    return null;  // In case all values are 0
  }

  getMiTanksColor(alertType : any){
    if(alertType == 'Extreme Danger'){
      return "#910018";
    }else if(alertType == 'Warning'){
      return "#FFA135";
    }else if(alertType == 'Caution'){
      return "#FFFD50";
    }else if(alertType == 'Danger'){
      return "#FF0019";
    }else if(alertType == 'Normal'){
      return "#008021";
    }else{
      return "#ffffff"
    }
  }

  getMiTanksPolygonColor(alertType : any){
    if(alertType == 'EXTREME_DANGER'){
      return "#910018";
    }else if(alertType == 'WARNING'){
      return "#FFA135";
    }else if(alertType == 'CAUTION'){
      return "#FFFD50";
    }else if(alertType == 'DANGER'){
      return "#FF0019";
    }else if(alertType == 'NORMAL'){
      return "#008021";
    }else{
      return "#005FED"
    }
  }
 
  addMITanksMandalClusterLayer(feature, mapObject: L.Map, urlParams,gisMapComp?) {
    let Radius = 8;
    // fillColor: "#f4faff",
    var outerCircleOptions = {
      stroke: true, fill: true, color: "#3488e2", weight: 2, fillColor: "#f4faff",
      fillOpacity: 1, radius: this.getCircleMarkerRadius(mapObject.getZoom(), Radius), pane: "popUp"
    };
    let concentricCircleLayer = new L.LayerGroup();
    let latlng: [number, number]
    latlng = [feature.geometry.coordinates[1], feature.geometry.coordinates[0]];
    let miTanksCount;
    let uuid = null;
    uuid = feature.properties.uuid; // mandal uuid
    if (uuid != null) {
      outerCircleOptions['fillColor'] = this.miTanksMandalData[uuid] ? this.miTanksMandalData[uuid]['color'] : '#f4faff';
      miTanksCount = this.miTanksMandalData[uuid] ? this.miTanksMandalData[uuid]['count'] : '-';
    }
    outerCircleOptions["properties"] = feature.properties;
    let outerCircle = L.circleMarker(latlng, outerCircleOptions);
    if (miTanksCount) {
      outerCircle.bindTooltip(miTanksCount.toString(), { className: "distText", permanent: true, direction: "center" }).openTooltip();
    }

    outerCircle.on({
      click: (e) => {
        let data = e['sourceTarget']['options']['properties'];
        this.getParamsForMandalClusterOnFromMapEvent(urlParams, data,mapObject,gisMapComp);

      }
    },
    )

    if (!isNullOrUndefined(mapObject)) {
      let initialZoom = LOCATIONS_ZOOM[VisibilityMapConstants.LOCATIONS.INDIA];
      if(LOCATIONS_ZOOM[urlParams['dashboardView']]){
        initialZoom = LOCATIONS_ZOOM[urlParams['dashboardView']];
      }
      mapObject.on({
        zoomend: (e: L.LeafletEvent) => {
          let currentZoom = mapObject.getZoom();
          let diff = currentZoom - initialZoom;
          if (diff > 0)
            outerCircle.setRadius(this.getCircleMarkerRadius(currentZoom, Radius - 2));
          else if (diff < 0)
            outerCircle.setRadius(this.getCircleMarkerRadius(currentZoom, Radius - 5));
          else
            outerCircle.setRadius(this.getCircleMarkerRadius(currentZoom, Radius));
        }
      })
    }
    concentricCircleLayer.addLayer(outerCircle);
    return concentricCircleLayer;
  }

  addMITanksClusterLayer(feature, mapObject: L.Map, urlParams, gisMapComp?) {
    urlParams = JSON.parse(JSON.stringify(urlParams));

    if(urlParams['view'] == 'PROJECT')
      urlParams['cType'] = VisibilityMapConstants.LOCATIONS.SUB_COMMAND_AREA;
    else if(urlParams['view'] == 'ADMIN')
      urlParams['cType'] = VisibilityMapConstants.LOCATIONS.DISTRICT;
    else
      urlParams['cType'] = VisibilityMapConstants.LOCATIONS.BASIN;  
    let Radius = 10;
    // fillColor: "#f4faff",
    var outerCircleOptions = {
      stroke: true, fill: true, color: "#3488e2", weight: 2, fillColor: "#f4faff",
      fillOpacity: 1, radius: this.getCircleMarkerRadius(mapObject.getZoom(), Radius), pane: "popUp"
    };
    let concentricCircleLayer = new L.LayerGroup();
    let latlng: [number, number]
    latlng = [feature.geometry.coordinates[1], feature.geometry.coordinates[0]];
    let miTanksCount;
    let uuid = this.getUUIDFromLayerFeature(urlParams, feature);
    if (uuid != null) {
      outerCircleOptions['fillColor'] = this.miTanksData[uuid] ? this.miTanksData[uuid]['color'] : '#f4faff';
      miTanksCount = this.miTanksData[uuid] ? this.miTanksData[uuid]['count'] : '-';
    }
    outerCircleOptions["properties"] = feature.properties;
    let outerCircle = L.circleMarker(latlng, outerCircleOptions);
    if (miTanksCount) {
      outerCircle.bindTooltip(miTanksCount.toString(), { className: "distText", permanent: true, direction: "center" }).openTooltip();
    }
    outerCircle.on({
      click: (e) => {
        let data = e['sourceTarget']['options']['properties'];
        this.getParamsOnFromMapEvent(urlParams, data, gisMapComp);
      }
    },
    )

    if (!isNullOrUndefined(mapObject)) {
      let initialZoom = LOCATIONS_ZOOM[VisibilityMapConstants.LOCATIONS.INDIA];
      if(LOCATIONS_ZOOM[urlParams['dashboardView']]){
        initialZoom = LOCATIONS_ZOOM[urlParams['dashboardView']];
      }
      mapObject.on({
        zoomend: (e: L.LeafletEvent) => {
          let currentZoom = mapObject.getZoom();
          let diff = currentZoom - initialZoom;
          if (diff > 0)
            outerCircle.setRadius(this.getCircleMarkerRadius(currentZoom, Radius - 2));
          else if (diff < 0)
            outerCircle.setRadius(this.getCircleMarkerRadius(currentZoom, Radius - 5));
          else
            outerCircle.setRadius(this.getCircleMarkerRadius(currentZoom, Radius));
        }
      })
    }
    concentricCircleLayer.addLayer(outerCircle);
    return concentricCircleLayer;
  }

  getUUIDFromLayerFeature(params, feature) {
    let uuid = null;
    if (params['cType'] == VisibilityMapConstants.LOCATIONS.DISTRICT) {
      uuid = feature.properties.uuid;
    } else if (params['cType'] == VisibilityMapConstants.LOCATIONS.BASIN) {
      uuid = feature.properties.uuid;
    } else if (params['cType'] == VisibilityMapConstants.LOCATIONS.BLOCK) {
      uuid = feature.properties.uuid;
    } else if (params['cType'] == VisibilityMapConstants.LOCATIONS.SUBBASIN) {
      uuid = feature.properties.uuid;
    } else if (params['cType'] == VisibilityMapConstants.LOCATIONS.COMMAND_AREA) {
      uuid = feature.properties.scmduid;
    } else if (params['cType'] == VisibilityMapConstants.LOCATIONS.SUB_COMMAND_AREA) {
      uuid = feature.properties.scmduid;
    } else if (params['cType'] == VisibilityMapConstants.LOCATIONS.COMMAND_DISTRICT) {
      uuid = feature.properties.cmdistuid;
    } else if (params['cType'] == VisibilityMapConstants.LOCATIONS.COMMAND_MANDAL) {
      uuid = feature.properties.cmdmanduid;
    }
    return uuid;
  }

  getParamsForMandalClusterOnFromMapEvent(urlParams, data,mapObj,gisMapComp) {
    let lat,long;
    lat = data['latitude'] ? data['latitude'] : 0;
    long = data['longitude'] ? data['longitude'] : 0;
    mapObj.setView([lat,long],LOCATIONS_ZOOM_RANGE.VILLAGE.MIN+2);
    urlParams['locName'] = data['block'];
    urlParams['pUUID'] = data['uuid'];
    urlParams['iPUUID'] = data['dist_uuid'];
    urlParams['pType'] = VisibilityMapConstants.LOCATIONS.BLOCK;
    urlParams['cType'] = VisibilityMapConstants.LOCATIONS.MITANK;
    urlParams['actionType'] = 'mapClick';
    console.log('params :::::',urlParams,data);
    this.removeGEOJSONLayers(gisMapComp)
    var layerList = [];
    for (let layer in MITANK_POLYGON_LAYER) {
      let list = MITANK_POLYGON_LAYER[layer];
      list['cqlfilter'] = "hw_blk_uui='"+data['uuid']+"'";
      layerList[layer] = list;
    }
    this.addSrcWiseGEOJSONLayers(layerList,gisMapComp,urlParams);
    // this.gisUtils.setSelectedParams(urlParams);
  }
  removeGEOJSONLayers(gisMapComp) {
    let geoJSONLayers = ["Mitanks Polygon","Mitanks in Normal","Mitanks in Caution","Mitanks in Warning","Mitanks in Danger","Mitanks in Extreme Danger","MiTank_Mandal_Structures Count"];
    this.removeLayers(gisMapComp, geoJSONLayers);
  }

  removeLayers(gisMapComp, layerList) {
    for (let layer of layerList) {
      if (gisMapComp.map && gisMapComp.layers && gisMapComp.layers.overlaylayers && gisMapComp.layers.overlaylayers[layer] && gisMapComp.map.hasLayer(gisMapComp.layers.overlaylayers[layer])) {
        gisMapComp.map.removeLayer(gisMapComp.layers.overlaylayers[layer]);
      }
      delete gisMapComp.layers.overlaylayers[layer];
      delete gisMapComp.activeLayers[layer];
    }
  }

  getParamsOnFromMapEvent(urlParams, data, gisMapComp) {
    let locName, pUUID, parentLoc;
    let lat,long;
    lat = data['latitude'] ? data['latitude'] : 0;
    long = data['longitude'] ? data['longitude'] : 0;
    gisMapComp.map.setView([lat,long],LOCATIONS_ZOOM_RANGE.BLOCK.MIN);
    this.removeGEOJSONLayers(gisMapComp)
    var layerList = [];
    for (let layer in MITANK_MANDAL_CLUSTER) {
      let list = MITANK_MANDAL_CLUSTER[layer];
      // list['cqlfilter'] = "dist_uuid='"+data['uuid']+"'";
      layerList[layer] = list;
    }
    this.addSrcWiseGEOJSONLayers(layerList,gisMapComp,urlParams);
    // let currentZoom = gisMapComp.map.getZoom(), minZoom, maxZoom;
    // if (gisMapComp.params['view'] == VisibilityMapConstants.VIEWS.ADMIN) {
    //   minZoom = LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.DISTRICT].MIN;
    //   maxZoom = LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.DISTRICT].MAX;
    //   if (urlParams['cType'] == VisibilityMapConstants.LOCATIONS.DISTRICT || currentZoom >= minZoom && currentZoom <= maxZoom) {
    //     let options = urlParams;
    //     options['locName'] = data['district'];
    //     options['pUUID'] = data['uuid'];
    //     options['pType'] = VisibilityMapConstants.LOCATIONS.DISTRICT;
    //     options['cType'] = VisibilityMapConstants.LOCATIONS.BLOCK;
    //     options['actionType'] = 'mapClick';
    //     // this.gisUtils.setSelectedParams(options);
    //     return;
    //   }
    //   else if (urlParams['cType'] == VisibilityMapConstants.LOCATIONS.BLOCK) {
    //     locName = data['block'];
    //     pUUID = data['uuid'];
    //   }
    // }
    // else if(gisMapComp.params['view'] ==  VisibilityMapConstants.VIEWS.BASIN) {
    //   minZoom = LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.BASIN].MIN;
    //   maxZoom = LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.BASIN].MAX;
    //   if (urlParams['cType'] == VisibilityMapConstants.LOCATIONS.BASIN || currentZoom >= minZoom && currentZoom <= maxZoom) {
    //     let options = urlParams;
    //     options['locName'] = data['basin'];
    //     options['pUUID'] = data['uuid'];
    //     options['pType'] = VisibilityMapConstants.LOCATIONS.BASIN;
    //     options['cType'] = VisibilityMapConstants.LOCATIONS.SUBBASIN;
    //     options['actionType'] = 'mapClick';
    //     // this.gisUtils.setSelectedParams(options);
    //     return; 
    //   }
    //   else if (urlParams['cType'] == VisibilityMapConstants.LOCATIONS.SUBBASIN) {
    //     locName = data['sub_basin'];
    //     pUUID = data['uuid'];
    //   }
    // }
    
    // this.onLocationClick(locName, pUUID, urlParams);
  }

  addMITanksPolygonLayer(layer, map: L.Map, urlParams, gisMapComp,feature) {
    let gecLayerObj;
    // console.log('layer ::',feature,this.alertsColorData[feature.properties['uuid_2']],feature.properties['uuid_2'])
    let trackColor = this.getMiTanksPolygonColor(this.alertsColorData[feature.properties['uuid_2']]);
    // console.log('trackcolor ::',trackColor)
    layer.setStyle(
      {
        weight: 1,
        fill: true,
        fillColor: '#FFCCCC',
        color:trackColor,
        fillOpacity: 0.5,
        opacity: 1,
        pane: 'popUp',
        stroke: true,
  });
  layer.on({
      click: (e: L.LayerEvent) => {
        const parsedParams = e['sourceTarget']['feature']['properties']['additional_params'] 
        ? JSON.parse(e['sourceTarget']['feature']['properties']['additional_params']) 
        : {};
        let layer = e.target;
        // trackColor = layer.options.fillColor;
        // layer.setStyle(
        //   {
        //     weight: 1,
        //     fill: true,
        //     fillColor: '#FFCCCC',
        //     color: '#2CD9C5',
        //     fillOpacity: 0.5,
        //     opacity: 1,
        //     pane: 'popUp',
        //     stroke: true,
        //   }
        // )
        let htmlContent;
        htmlContent = this.setHtmlContentForMiTanksStatePopup(e['sourceTarget']['feature']['properties'], urlParams,parsedParams)

        const popup = R.responsivePopup({ className :'alert-popup', hasTip: true, autoPan: false, minWidth: 250, pane: 'popUpGeoJson', maxWidth: 600, closeButton: false })
        popup.setLatLng(e['latlng'])
          .setContent(htmlContent).openOn(map);
        if (!L.Browser.ie && !L.Browser.edge)
          layer.bringToFront();

        // map.fitBounds(layer.getBounds());
        // gisMapComp.map.setView([e['latlng']['lat'],e['latlng']['lng']],LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN+4)
        urlParams['pointType'] = 'MITANK';
        urlParams['locName'] = e['sourceTarget']['feature']['properties']['tank_name'];
        urlParams['pUUID'] = e['sourceTarget']['feature']['properties']['uuid_2'];
        urlParams['pType'] = VisibilityMapConstants.LOCATIONS.MITANK;
        urlParams['cType'] = VisibilityMapConstants.LOCATIONS.MITANK;
        urlParams['lng'] = e['sourceTarget']['feature']['properties']['longitude'];
        urlParams['lat'] = e['sourceTarget']['feature']['properties']['latitude'];
        urlParams['actionType'] = 'sensorClick';
        urlParams['pointClick'] = true;
        this.gisUtils.setSelectedParams(urlParams);
        this.addSelfCatchmentBoundary(map, gisMapComp,urlParams['pointType'] ,feature.properties);

      },
      mouseover: (e: L.LayerEvent) => {
      },
      mouseout: (e: L.LayerEvent) => {
      }
    });
    return (gecLayerObj);
  }

  setHtmlContentForMiTanksStatePopup(popupData, params?,parsedParams?) {
    var htmlString = "<html><body>";
    htmlString += '<div class="alert-poupup-table">';
    htmlString += `<div class="card-body p-0">
       <table class="table table-sm m-0 table-bordered ">`;
    htmlString += `<tbody>
        <tr>
           <th> Tank</th>
           <td>${popupData['tank_name']}</td>
         </tr>
         <tr >
           <th> Agency </th>
           <td>${popupData['agency'] || 'TAMILNADU TANK'}</td>
         </tr>
         <tr>
           <th> District </th>
           <td>${parsedParams && parsedParams.district?parsedParams.district:popupData['district'] || '-'}</td>
         </tr>
          <tr>
           <th> Block </th>
           <td>${parsedParams && parsedParams.block?parsedParams.block:popupData['block'] || popupData['mandal_n_1']||'-'}</td>
         </tr>
       
      
     </table>
   </div>
   </div>`;
    return htmlString;
  }

  setHtmlContentForMiTankPoints(properties) {
    var htmlString = "<html><body>";
    htmlString += '<div class="alert-poupup-table">';
    htmlString += `<div class="card-body p-0">
       <table class="table table-sm m-0 table-bordered  ">`;
    htmlString += `<tbody>
        <tr>
           <th> Tank</th>
           <td>${properties['tank_nam_1']}</td>
         </tr>
         <tr>
           <th> District</th>
           <td>${properties['district']}</td>
         </tr>
         <tr>
           <th> Block</th>
           <td>${properties['mandal']}</td>
         </tr>
     </table>
   </div>
   </div>`;
    return htmlString;
  }

}
